{
    "loading": "Chargement...",
    "yes": "Oui",
    "no": "Non",
    "cancel": "Annuler",
    "validate": "Valider",
    "edit": "Modifier",
    "close": "Fermer",
    "retry": "Réessayer",
    "details": "Détails",
    "total": "Total",
    "hours": "Heures",
    "minutes": "Minutes",
    "home": "Accueil",
    "next": "Suivant",
    "save": "Enregistrer",
    "know_more": "En savoir plus",
    "interval": "Du %{from} au %{to}",
    "absences": "Absences",
    "no_network": "Connexion interrompue",
    "network_will_reconnect": "Il semble que votre connexion internet a été interrompue.\n\nL'application se reconnectera automatiquement une fois la connexion rétablie.",
    "heure": {
        "zero": "Aucune heure",
        "one": "1 heure",
        "other": "{{count}} heures"
    },
    "education_level": {
        "uni_epf": "Haute école universitaire (UNI, EPF)",
        "hes_hep": "Haute école spécialisée (HES), haute école, etc.",
        "high_school": "Formation professionnelle supérieure",
        "teaching_certificate": "Brevet d’enseignement",
        "baccalaureate": "Maturité fédérale",
        "cfc": "Apprentissage complet (CFC)",
        "in_company": "Formation acquise en entreprise",
        "without": "Sans formation professionnelle complète"
    },
    "work_permit": {
        "permit_b": "Permis B (autorisation de séjour)",
        "permit_c": "Permis C",
        "permit_g": "Permis G (permis frontalier)",
        "permit_l": "Permis L (autorisation de courte durée)",
        "permit_n": "Permis N (requérant d’asile)",
        "permit_s": "Permis S (personnes à protéger)",
        "permit_other": "Autre permis",
        "in_process": "En cours"
    },
    "documentType": {
        "companyPolicy": "Règlement d'entreprise",
        "experience": "Diplôme ou certificat",
        "profilePicture": "Photo de profil",
        "workPermit": "Permis de séjour"
    },
    "civility": {
        "female": "Madame",
        "male": "Monsieur"
    },
    "errors": {
        "unknown_error": "Une erreur inconnue est survenue. Notre équipe va vérifier ce qu'il se passe.",
        "mission_not_found": "Le contrat de travail n'existe pas!",
        "asset_error": "Une erreur est survenue lors de la génération du contenu.",
        "save_failed": "La sauvegarde a échoué.",
        "field_name": {
            "email": "Cet e-mail n'est pas valide.",
            "phoneNumber": "Le numéro de téléphone n'est pas valide.",
            "avs_number": "Numéro AVS (déjà utilisé)"
        },
        "avs_number": "Il y a une erreur dans le numéro AVS.",
        "pagination_error": "Erreur lors de la récupération des données",
        "geolocation_denied": "L’accès à la localisation a été bloqué. Vous pouvez l'activer dans les paramètres à tout moment.",
        "saving": "Une erreur est survenue lors de l'enregistrement des données.",
        "numberMin": "Doit être supérieur ou égal à {{min}}",
        "numberMax": "Doit être inférieur ou égal à {{max}}"
    },
    "mesoneer": {
        "status_info": {
            "confirmed": "Votre identité est déjà confirmée.\n[Retourner à l'accueil](Home)",
            "pending": "Votre identité n'a pas encore été confirmée, veuillez patienter encore un moment.",
            "rejected": "La vérification de votre identité n'a pas été acceptée. Contactez-nous pour plus d'information.",
            "failed": "La vérification de votre identité a échoué, contactez-nous pour plus d'information.",
            "timeout": "Votre identité n'a pas été confirmée dans le temps imparti, contactez-nous pour plus d'information.",
            "not_required": "La vérification de votre identité n'est pas requise.",
            "deleted": "Votre identité a été supprimée, contactez-nous pour plus d'information.",
            "corrupted": "Les données de vérification de votre identité sont corrompues, veuillez nous contacter pour que nous puissions vous aider.",
            "success": "Votre identité a déjà été confirmée.\n[Retourner à l'accueil](Home)",
            "unknown": "Un problème est survenu. Veuillez nous contacter pour que nous puissions le résoudre avec vous."
        }
    },
    "user": {
        "email": "E-mail",
        "first_name": "Prénom",
        "last_name": "Nom",
        "address": "Adresse",
        "birthdate": "Date de naissance",
        "phone": "Téléphone",
        "gender": "Civilité",
        "gender_male": "Homme",
        "gender_female": "Femme",
        "gender_unknown": "Inconnu",
        "marital_status": "État civil",
        "single": "Célibataire",
        "married": "Marié",
        "divorced": "Divorcé",
        "widowed": "Veuf",
        "marital_status_from": "Depuis le",
        "need_email_validation": "Votre e-mail n'a pas encore été validé.",
        "errors": {
            "first_name": "Le prénom est obligatoire.",
            "last_name": "Le nom est obligatoire.",
            "email": "L'adresse e-mail est obligatoire.",
            "birthdate": "La date de naissance n'est pas correcte.",
            "address": "L'adresse est obligatoire",
            "save": "Oups! Une erreur est survenue lors de la sauvegarde de vos informations.",
            "birthdate_18yo": "L'âge minimum requis est de 18 ans révolus.",
            "not_permit_c": "Un permis C ou un passeport suisse sont requis.",
            "name_missing": "Le nom est obligatoire.",
            "name_too_short": "Le nom est trop court.",
            "name_too_long": "Le nom est trop long.",
            "name_bad_character": "Le nom contient des caractères non valides."
        },
        "actions": {
            "edit_user": "Modifier mon profil",
            "lpp_to_complete": "Plan de prévoyance (à compléter)",
            "lpp": "Plan de prévoyance"
        },
        "residential_address": "Adresse de domicile",
        "gender_kid_male": "Garçon",
        "gender_kid_female": "Fille",
        "married_with_x_revenues": {
            "zero": "",
            "one": "Marié, avec 1 revenu",
            "other": "Marié, avec %{count} revenus"
        },
        "business_email_info": "Votre e-mail professionnel",
        "business_email_need_validation": "Votre e-mail n'a pas encore été validé.",
        "birth_year": "Année de naissance",
        "business_email_verification_banner": "Nous vous avons envoyé un e-mail de vérification. Cliquez sur le lien qu'il contient pour confirmer votre adresse e-mail."
    },
    "profile": {
        "personal_info": "Informations personnelles",
        "change_profile_picture": "Changer de photo",
        "client_list": "Mes employeurs",
        "edit": "Modifier",
        "user_account": "Compte",
        "logout": "Se déconnecter",
        "logout_title": "Déconnexion",
        "logout_description": "Êtes-vous sûr de vouloir vous déconnecter?",
        "logout_confirm": "Se déconnecter",
        "do_not_click": "Ne pas cliquer",
        "civil_state": "%{state} depuis le %{date}",
        "civil_state_simple": "%{state}",
        "lpp_title": "Prévoyance professionnelle",
        "contact_support": "Contacter l'assistance",
        "work_permit_label": "Permis de séjour",
        "work_permit_to_complete": "Permis de séjour (à compléter)",
        "missing_avs_number": "Numéro AVS manquant",
        "missing_bank_account": "Informations bancaires manquantes",
        "upload_document": "Ajouter un document",
        "nationality": "Nationalité",
        "save_logo_error": "Une erreur est survenue lors de la sauvegarde du logo.",
        "save_avatar_error": "Une erreur est survenue lors de la sauvegarde de la photo de profil.",
        "save_worker_error": "Une erreur est survenue lors de la sauvegarde du profil.",
        "title": {
            "male": "M. %{firstName} %{lastName}",
            "female": "Mme %{firstName} %{lastName}",
            "unknown": "%{firstName} %{lastName}"
        },
        "deleteAccount": "Supprimer mon compte Lift",
        "delete_account_title": "Supprimer mon compte",
        "delete_account_description": "Vos données seront effacées et ne pourront plus être récupérées.",
        "delete_account_confirm": "Supprimer",
        "delete_account_success": "Compte supprimé",
        "delete_account_error": "Suppression annulée",
        "delete_account_error_description": "Vous ne pouvez pas supprimer votre compte si un contrat de travail est en cours, en attente de signature ou sur le point de débuter.",
        "sample_skribble": "TEST signature",
        "avs_number": "Numéro AVS",
        "contact_us_for_change": "Pour tout changement, veuillez contacter l'assistance.",
        "avs_number_optional": "Numéro AVS (optionnel)",
        "change_profile": "Changer de profil",
        "pending_creation": "Profil en cours de création",
        "pending_validation": "Profil en cours de validation",
        "rejected_validation": "Vérification échouée",
        "worker": "Employé",
        "client": "Employeur",
        "add_talent_profile": "Ajouter un profil employé",
        "add_client_profile": "Ajouter un profil employeur entreprise",
        "add_talent_profile_error": "Une erreur est survenue lors de la sauvegarde du logo.",
        "delete": {
            "worker": {
                "profile": "Supprimer le profil employé",
                "title": "Supprimer mon profil employé",
                "description": "Les données de votre profil employé seront effacées et ne pourront plus être récupérées.",
                "confirm": "Oui, supprimer mon profil employé",
                "success": "Profil employé supprimé",
                "error_description": "Vous ne pouvez pas supprimer votre profil employé si un contrat de travail est en cours, en attente de signature ou sur le point de débuter."
            },
            "client": {
                "profile": "Supprimer le profil employeur",
                "title": "Supprimer mon profil employeur",
                "description": "Les données de votre profil employeur seront effacées et ne pourront plus être récupérées.",
                "confirm": "Oui, supprimer mon profil employeur",
                "success": "Profil employeur supprimé",
                "error_description": "Vous ne pouvez pas supprimer votre profil employeur si un contrat de travail est en cours, en attente de signature ou sur le point de débuter."
            },
            "private_client": {
                "profile": "Supprimer le profil employeur domestique",
                "title": "Supprimer mon profil employeur domestique",
                "description": "Les données de votre profil employeur domestique seront effacées et ne pourront plus être récupérées.",
                "confirm": "Oui, supprimer mon profil employeur privé",
                "success": "Profil employeur domestique supprimé",
                "error_description": "Vous ne pouvez pas supprimer votre profil employeur domestique si un contrat de travail est en cours, en attente de signature ou sur le point de débuter."
            }
        },
        "my_activity_log": "Mon journal d'activités",
        "ijm_document": "Indemnités journalières en cas de maladie (IJM)",
        "private_client": "Employeur domestique",
        "add_private_client_profile": "Ajouter un profil employeur domestique",
        "my_invoices": "Factures",
        "my_colleagues": "Collègues",
        "logout_cancel": "Non, annuler",
        "framework_contract": "Contrat de co-emploi",
        "awaiting": "En attente",
        "signed": "Signé",
        "rejected": "Rejeté",
        "rejected_framework_contract": "**Contrat refusé par {{rejectedBy}}:**\n\"{{reason}}\"",
        "warnings": {
            "kyc_required": "Votre identité n'a pas encore été vérifiée. Lancez la vérification pour activer toutes les fonctionnalités.",
            "client_not_verified": "Nous vérifions actuellement les informations de votre entreprise (ce processus peut prendre jusqu'à 72 h).\nVous recevrez une notification une fois la vérification terminée.",
            "client_not_verified_no_lse": "Vous n'avez pas encore signé le contrat de co-emploi avec Lift.\nVeuillez le signer pour activer votre compte.",
            "client_refused": "La vérification de votre entreprise n'a pas été acceptée.\nRaison : %{rejectedReason}\nContactez-nous pour plus d'information.",
            "client_reject": "Le contrat de co-emploi a été refusé par un membre de votre entreprise. Les règles applicables aux contrats de travail ne sont pas définies.\nRaison : %{rejectedReason}\nContactez-nous pour plus d'information.",
            "launch_kyc": "Lancer la vérification",
            "show_client_contract": "Voir le contrat",
            "contact_support": "Contacter l'assistance",
            "client_handwritten_in_process": "Votre convention de co-emploi vous a été envoyée par courrier. Signez-la et retournez-la-nous afin que votre contrat de travail puisse être créé."
        }
    },
    "client": {
        "name": "Nom de la société",
        "address": "Adresse de la société"
    },
    "documents": {
        "permission_denied": "La permission a été refusée. Accédez aux paramètres de votre téléphone.",
        "upload_error": "Une erreur est survenue lors du chargement du document.",
        "select_error": "Une erreur est survenue lors de la sélection du document.",
        "camera_permission_previously_denied": "Accès caméra non autorisé",
        "library_permission_previously_denied": "Accès aux photos non autorisé",
        "enable_permission_in_settings": "Activez-le dans les paramètres du téléphone",
        "settings": "Paramètres",
        "invalid_file_type": "Ce type de fichier n'est pas supporté. Veuillez sélectionner une image."
    },
    "lpp": {
        "plan_name": {
            "defaultPlan": "Plan de prévoyance par défaut"
        },
        "editor": {
            "title": "Prévoyance professionnelle (LPP)",
            "no_lpp": "Aucune cotisation LPP",
            "description_lse": "Vous pouvez choisir parmi les différentes options de cotisation LPP proposées par notre partenaire de prévoyance.\n\nDans le contexte de la location de services, la cotisation LPP est prélevée dès le premier franc de salaire versé.",
            "description_no_lse": "Vous pouvez choisir parmi les différentes options de cotisation LPP proposées par notre partenaire de prévoyance.\n\nIl est possible que certains employés soient exemptés de l'obligation de cotiser à la LPP, en fonction de leur âge et de leur salaire."
        }
    },
    "phone_contact": {
        "search": "Rechercher un contact",
        "no_contact": "Aucun contact trouvé",
        "contact_error": "Une erreur est survenue lors de la récupération des contacts.",
        "permission_denied": "Vous n'avez pas autorisé l'application à accéder à vos contacts. Vous pouvez modifier cela dans les paramètres de votre téléphone."
    },
    "worker_profile": {
        "avs_number": "Numéro AVS",
        "bank_info": "Informations bancaires",
        "bank_iban": "IBAN",
        "bank_name": "Nom de la banque",
        "update_success": "Profil mis à jour",
        "certifications": "Diplômes et certifications",
        "education_level": "Niveau de formation",
        "missing_education_level": "Niveau de formation manquant",
        "years_of_experience": "Années d'expérience",
        "missing_years_of_experience": "Années d'expérience manquantes",
        "framework_contract": "Détails du contrat-cadre",
        "mission_contract": "Détails du contrat de travail",
        "errors": {
            "email": "L'adresse e-mail est obligatoire.",
            "avs_number": "Le numéro AVS n'est pas correct.",
            "birthdate": "La date de naissance n'est pas correcte.",
            "address": "L'adresse est obligatoire.",
            "education_level": "Niveau de formation manquant",
            "years_of_experience": "Années d'expérience manquantes",
            "iban_number": "IBAN non valide",
            "iban_bank_name": "Nom de la banque non valide",
            "save": "Une erreur s'est produite lors de la sauvegarde de vos informations.",
            "bic_number": "BIC non valide"
        },
        "trainings_and_experiences": "Formations et expériences",
        "bank_bic": "BIC",
        "custom_beneficiary": "Bénéficiaire personnalisé",
        "bank_beneficiary": "Bénéficiaire",
        "is_revolut_account": "Est-ce un compte REVOLUT ?",
        "revolut_account_forbidden": "Un salaire ne peut être versé sur un compte REVOLUT."
    },
    "worker_details": {
        "title": "Employé",
        "documents_title": "Documents",
        "mission_count": {
            "zero": "Aucun contrat pour le moment",
            "one": "1 contrat de travail",
            "other": "%{count} contrats de travail"
        },
        "years_of_experience": {
            "zero": "Aucune expérience",
            "one": "1 an",
            "other": "%{count} ans"
        },
        "create_mission_action": "Créer un contrat de travail avec %{name}",
        "list_missions_action": "Liste des contrats de travail",
        "list_timesheet_action": "Liste des fiches horaires",
        "list_invoices_action": "Liste des factures",
        "remove_talent": "Effacer de mon répertoire",
        "remove_worker_action": "Supprimer de mon répertoire d'employés",
        "remove_worker_title": "Supprimer l'employé",
        "remove_worker_description": "Êtes-vous sûr de vouloir supprimer cet employé de votre répertoire?",
        "remove_confirm": "Oui, supprimer.",
        "remove_cancel": "Non, annuler.",
        "remove_worker_done": "L'employé a été supprimé de votre répertoire.",
        "curriculum_vitae_pdf": "Curriculum vitae PDF",
        "without_qualifications": "Sans qualifications",
        "qualifications": "Qualifications",
        "trainings": "Formation",
        "experiences": "Expérience professionnelle",
        "none": "Aucune",
        "no_trainings": "Aucune formation n’a encore été indiquée pour cet employé.",
        "no_experiences": "Aucune expérience professionnelle n’a été indiquée pour le moment."
    },
    "client_profile": {
        "title": "Profil employeur",
        "client_name": "Nom",
        "client_address": "Adresse",
        "change_client_logo": "Changer le logo de l'entreprise",
        "client_info": "Entreprise",
        "framework_contract": "Détails du contrat-cadre",
        "mission_contract": "Détails du contrat de location",
        "client_info_data": "Données de l’entreprise",
        "client_title": "Entreprise",
        "contact_info": "Coordonnées de contact"
    },
    "client_worker_cell": {
        "invitation": "Invitation en attente",
        "mission_count": {
            "zero": "Aucun contrat de travail",
            "one": "1 contrat de travail",
            "other": "%{count} contrats de travail"
        },
        "cannot_sign_contracts": "n'est pas habilité à signer des contrats",
        "incomplete_profile": "Profil employé en cours de création"
    },
    "mission_onboarding": {
        "contact_name": "Personne de contact",
        "contact_phone": "Téléphone de contact",
        "contact_email": "E-mail de contact",
        "meeting_address": "Adresse de rendez-vous",
        "meeting_address_placeholder": "Saisissez l'adresse de rendez-vous",
        "meeting_date": "Date de rendez-vous",
        "meeting_time": "Heure de rendez-vous",
        "instructions": "Instructions",
        "instructions_placeholder": "Tenue vestimentaire, pièce d’identité, permis de conduire, équipement spécifique, etc.",
        "instructions_ok": "Confirmer"
    },
    "invitation": {
        "from": "Invitation de:",
        "to": "à: %{phoneNumber} (%{firstName} %{lastName})",
        "description": "%{senderName} souhaiterait collaborer avec vous.\n\n<br><br>\n\nEn acceptant, vous autorisez %{senderName} à vous proposer des contrats de travail et à accéder à votre profil (CV, diplômes, certificats d'études).",
        "invitation_not_found": "L'invitation n'existe plus!",
        "action": {
            "accept": "Accepter",
            "reject": "Refuser",
            "cancel": "Supprimer l'invitation",
            "close": "Fermer",
            "success": "Invitation acceptée",
            "create_profile": "Créer un profil employé",
            "switch_profile": "Changer de profil"
        },
        "send": {
            "errors": {
                "selfInviteError": "Non, non! Vous ne pouvez pas vous inviter vous-même!",
                "workerExistsError": "Ce numéro de téléphone appartient déjà à un de vos employés.",
                "sendError": "Une erreur est survenue lors de l'envoi de l'invitation.",
                "isClientPhoneNumberError": "Vous ne pouvez pas envoyer d'invitation à ce numéro de téléphone car il appartient à un employeur.",
                "alreadyInvitedByOtherProfile": "Une invitation a déjà été envoyée à ce numéro de téléphone pour cette entreprise."
            },
            "phoneNumber": "Numéro de téléphone",
            "my_contacts": "Choisir un contact depuis mon carnet d'adresse",
            "sendButton": "Inviter",
            "resendButton": "Renvoyer l'invitation",
            "firstName": "Prénom",
            "lastName": "Nom",
            "client_not_verified": "Nous vérifions actuellement les informations de votre entreprise (ce processus peut prendre jusqu’à 72 h). \nUne fois la vérification terminée, vous pourrez inviter vos collaborateurs.",
            "launch_kyc": "Lancer la vérification",
            "worker": {
                "title": "Inviter un employé",
                "explaination": "L'employé apparaîtra dans votre liste dès qu'il aura accepté votre invitation. Vous pourrez ensuite établir un contrat de travail avec lui.",
                "kyc_required": "Vous ne pouvez pas inviter d’employé tant que votre identité n’a pas été vérifiée."
            },
            "client": {
                "title": "Inviter un collègue",
                "explaination": "Votre collègue apparaîtra dans votre liste dès qu'il aura accepté votre invitation. Il pourra ensuite créer et signer des contrats pour {{clientName}}.",
                "kyc_required": "Vous ne pouvez pas inviter de collègue tant que votre identité n’a pas été vérifiée."
            },
            "client_refused": "La vérification de votre entreprise n'a pas été acceptée.\nRaison : %{rejectedReason}\nContactez-nous pour plus d'information.",
            "contact_support": "Contacter l'assistance",
            "client_not_verified_no_lse": "Vous n’avez pas encore signé votre convention de co-emploi avec Lift.\nSignez-la pour pouvoir inviter vos employés.",
            "client_reject": "La convention de co-emploi a été refusée par un membre de votre entreprise. Les conditions nécessaires à la création des contrats de travail ne sont donc pas définies et l’invitation de vos employés est bloquée.\nRaison : %{rejectedReason}\nContactez-nous pour plus d’informations.",
            "show_client_contract": "Voir le contrat",
            "client_handwritten_in_process": "Votre convention de co-emploi vous a été envoyée par courrier. Signez-la et retournez-la-nous afin que votre contrat de travail puisse être créé."
        },
        "action_result": {
            "accept": {
                "success": "Invitation acceptée",
                "error": "Une erreur est survenue lors de l'acceptation de l'invitation."
            },
            "reject": {
                "success": "Invitation refusée",
                "error": "Une erreur est survenue lors du refus de l'invitation."
            },
            "cancel": {
                "success": "Invitation supprimée",
                "error": "Une erreur est survenue lors de l'annulation de l'invitation."
            },
            "sent": {
                "success": "Invitation envoyée",
                "error": "Une erreur est survenue lors de l'envoi de l'invitation."
            },
            "resend": {
                "success": "L'invitation a été envoyée une nouvelle fois.",
                "error": "Une erreur est survenue lors de l'envoi de l'invitation."
            },
            "default": {
                "success": "Action effectuée",
                "error": "Une erreur inattendue est survenue. Notre équipe va vérifier ce qu'il se passe."
            }
        },
        "details": {
            "title": "Inviter un employé",
            "worker_title": "Invitation reçue",
            "description": "Lift est actuellement accessible aux personnes qui résident en Suisse, aux citoyens suisses et aux détenteurs d’un permis B, C, G, L ou S."
        },
        "error_bad_recipient": "Désolé, vous avez reçu cette invitation par erreur. Vous ne devriez pas recevoir d'invitation en tant qu'employeur.",
        "description_create": "%{senderName} souhaiterait collaborer avec vous!\n\n<br><br>\n\nPour collaborer avec %{senderName}, veuillez tout d'abord créer un profil employé. Vous pouvez créer ce nouveau profil sur votre compte existant.",
        "description_switch": "%{senderName} souhaiterait collaborer avec vous!\n\n<br><br>\n\nVeuillez changer de profil pour voir l'invitation que vous a envoyée %{senderName}."
    },
    "fees": {
        "repetition": {
            "day": "par jour",
            "worked_day": "par jour",
            "month": "par mois",
            "worked_month": "par mois",
            "total": "pour l'ensemble du contrat",
            "count": "par occurrence",
            "count_km": "par km"
        },
        "cct": {
            "hotel_apron_title": "Tabliers de service",
            "hotel_apron_description": "%{amount} par mois",
            "hotel_clothes_title": "Habits de travail pour les cuisiniers et les pâtissiers, vestes pour le personnel de service ou uniformes spéciaux",
            "hotel_clothes_description": "%{amount} par mois",
            "hotel_description": "–",
            "hotel_apron_description_2": "%{amount} %{repetition}",
            "hotel_clothes_description_2": "%{amount} %{repetition}",
            "repetition": {
                "month": "par mois",
                "total": "pour l'ensemble du contrat"
            }
        },
        "type": {
            "private_transport": {
                "title": "Frais de transport privé",
                "description": "Charges relatives aux trajets professionnels à une destination autre que le lieu de travail habituel (par ex.: un déplacement chez un client avec un véhicule privé)."
            },
            "food": {
                "title": "Frais de repas",
                "description": "Charges relatives aux repas pris pendant les pauses des jours travaillés sur les lieux de l'activité."
            },
            "public_transport": {
                "title": "Frais de transport public",
                "description": "Charges relatives aux trajets professionnels à une destination autre que le lieu de travail habituel (par ex.: un déplacement chez un client en transports publics)."
            },
            "phone": {
                "title": "Frais de téléphonie"
            },
            "remote_work": {
                "title": "Frais liés au télétravail"
            },
            "other": {
                "title": "Autres frais"
            },
            "otherText": {
                "title": "Frais \"%{text}\""
            }
        },
        "min_amount": "min. %{amount} %{repetition}",
        "count_unit": {
            "km": "km"
        }
    },
    "invoice": {
        "nav_title": "Factures"
    },
    "contract": {
        "nav_title": "Récapitulatif du contrat",
        "cancel_contract": "Annuler le contrat",
        "will_be_signed_with_mission": "Le contrat sera signé au démarrage de votre prochaine activité.",
        "signing_status": {
            "canceled_by_lse": "Annulé par Lift",
            "canceled_by_other": "Annulé par l'autre partie",
            "canceled_by_self": "Annulé par vous",
            "failed": "La signature du contrat a malheureusement échoué. Merci de contacter l'assistance afin que nous puissions vous aider à résoudre le problème.",
            "need_self_sign": "À vérifier et à signer",
            "need_other_sign": "À signer par l'autre partie",
            "need_sign": "En attente de signature",
            "need_seal": "En attente de la vérification par Lift",
            "success": "Signé par toutes les parties",
            "waiting_contract": "En attente de création des contrats",
            "waiting_self_sign": "En attente de vérification de votre identité",
            "aborted": "Contrat annulé",
            "signed": "Signé",
            "waiting_contract_asset": "En attente de finalisation des contrats",
            "unknown": "Statut inconnu"
        },
        "pdf_prefix": {
            "worker": "Contrat de travail",
            "client": "Contrat de location",
            "client_employment": "Contrat de travail"
        },
        "terminate_contract": "Demande de résiliation"
    },
    "mission": {
        "id": "ID",
        "start_date": "Début",
        "end_date": "Fin",
        "activity_name": "Activité",
        "job_title": "Intitulé",
        "address": "Lieu",
        "contract": "Contrat",
        "earning_type": "Type de contrat",
        "client": "Employeur",
        "documents": "Documents",
        "worker": "Employé",
        "working_percentage": "Pourcentage",
        "monthly": "Mensuel",
        "hourly": "Horaire",
        "working_percentage_format": "%{percent}%",
        "no_end_date": "–",
        "working_time": "Temps de travail",
        "working_time_info": "Détails des horaires",
        "classic": "Horaire normal",
        "specific": "Dates spécifiques",
        "schedule": "Semaine spécifique",
        "invoiced": "Salaire facturé",
        "gross_salary": "Salaire brut",
        "salary_hourly": "%{value}/heure",
        "salary_monthly": "%{value}/mois",
        "salary_weekly": "%{value}/semaine",
        "not_defined": "Non défini",
        "needAcceptation": "À signer",
        "waitingAcceptation": "En attente de signature",
        "nav_title": "Contrat de travail",
        "duration_with_end": "Du %{start} au %{end}",
        "duration_without_end": "Dès le %{start} (durée indéterminée)",
        "details": {
            "draft_description": "Ceci est une ébauche de contrat.\n\nVérifiez les informations ci-dessous avant de transmettre le contrat.",
            "pendingAcceptation_title": "À lire et à signer",
            "pendingAcceptation_description_need_accept": "Vérifiez les informations ci-dessous avant de valider la proposition.",
            "pendingAcceptation_description_waiting": "Ce contrat de travail a été soumis.\n\nNous attendons qu'il soit accepté.",
            "will_start_at": "Débutera le %{date}",
            "accepted_description": "Ce contrat de travail a été accepté. Il est en cours ou va débuter prochainement.",
            "pause_title": "Contrat de travail en pause",
            "pause_description": "Ce contrat de travail est en pause.",
            "cancelled_description": "Ce contrat a été annulé.",
            "terminated_description": "Ce contrat a été résilié.",
            "ended_description": "Ce contrat est terminé.",
            "onboarding": "Préparation",
            "show_onboarding": "Voir",
            "contract_asset_not_ready": "Votre contrat de travail n'est pas encore prêt, merci de patienter encore un instant.",
            "framework_asset_not_ready": "Votre contrat-cadre n'est pas encore prêt, merci de patienter encore un instant.",
            "contract_asset": "Contrat",
            "show_contract": "Voir",
            "contract_asset_title": "Contrat de travail",
            "contract_filename": "Contrat-%{contract_id}",
            "show_time_sheets": "Voir les fiches horaires",
            "cct": "Convention collective de travail",
            "client_fees": "Frais à la charge de l'employeur",
            "mission_deductions": "Déductions",
            "show_payroll_breakdown": "Décomptes",
            "mission_details": "Informations",
            "list_timesheet_action": "Liste des fiches horaires",
            "holiday_balance": "Solde de vacances",
            "overtime_balance": "Solde d'heures",
            "balance_date": "comptabilisé le %{date}",
            "owner": "Responsable",
            "mission_owner": "Responsable de contrat",
            "name_owner_description": "#### Désignez un responsable de contrat\nToute personne appartenant à l’entreprise peut être désignée à ce rôle. La signature du contrat, en revanche, est réservée aux personnes habilitées à signer.",
            "new_owner_selected": "Nouveau responsable désigné",
            "mission_history": "Historique du contrat",
            "cancelled_by_self": "Vous avez annulé ce contrat de travail",
            "cancelled_by_other": "Le contrat de travail a été annulé par {{personName}}",
            "cancelled_by_lse": "Le contrat de travail a été annulé par Lift",
            "change_owner": "Changer de responsable",
            "signer": "Signataires",
            "change_signer": "Changer de signataire",
            "confirm_read_annexes": "Je confirme avoir lu les annexes joints au contrat de travail",
            "draft_title": "Ébauche de contrat",
            "accepted_title": "Contrat de travail en cours",
            "cancelled_title": "Contrat annulé",
            "terminated_title": "Contrat résilié",
            "ended_title": "Contrat terminé",
            "accepted": "Contrat de travail en cours",
            "label": {
                "default": {
                    "draft": "Ébauche de contrat",
                    "pendingAcceptation": "Contrat à signer",
                    "accepted": "Contrat en cours",
                    "cancelled": "Contrat annulé",
                    "terminated": "Contrat en cours",
                    "ended": "Contrat terminé",
                    "canceled": "Contrat annulé"
                },
                "short": {
                    "draft": "Ébauche",
                    "pendingAcceptation": "À signer",
                    "accepted": "En cours",
                    "cancelled": "Annulé",
                    "terminated": "En cours",
                    "ended": "Terminé",
                    "rejected": "Refusé",
                    "accepted_amendment": "Accepté",
                    "canceled": "Annulé",
                    "applied": "En cours"
                },
                "unknown": "Statut inconnu"
            },
            "amendment": {
                "title": "Avenant du {{creationDate}}",
                "grossSalary": "Salaire: {{salaryAmount}}",
                "endDate": "Prolongation: {{contractEndDate}}",
                "verify_and_sign": "Vérifier et signer l'avenant",
                "refused_amendment": "**Avenant refusé:**\n\"{{reason}}\"",
                "see_more": "Voir les autres avenants",
                "canceled_amendment": "**Avenant annulé:**\n\"{{reason}}\"",
                "label": {
                    "short": {
                        "draft": "Ébauche",
                        "pendingAcceptation": "À signer",
                        "accepted": "Signé",
                        "applied": "En cours",
                        "rejected": "Refusé",
                        "canceled": "Annulé"
                    },
                    "unknown": "Statut inconnu"
                }
            }
        },
        "sign_contract": "Signer le contrat",
        "see_contract": "Voir le contrat",
        "cancel_mission": "Annuler le contrat de travail",
        "add_to_calendar": "Ajouter au calendrier",
        "reject_contract": "Refuser le contrat",
        "cancel_contract": "Annuler le contrat",
        "confirm_delete_title": "Supprimer le contrat de travail",
        "confirm_delete_description": "Êtes-vous sûr de vouloir supprimer ce contrat de travail?",
        "salary_projections": "Projections",
        "total_invoiced": "Total facturé",
        "net_salary": "Net pour l'employé",
        "error_forecast": "Erreur",
        "contact_other": "Contacter %{name}",
        "vacationDays": "Jours de vacances",
        "vacationDaysValue": "%{days} jours/an (100%)",
        "terminationDate": "Terminée %{date}",
        "period": "Période",
        "description": "Description",
        "contract_names": {
            "client": "Contrat de location",
            "worker": "Contrat de travail",
            "client_employment": "Contrat de travail"
        },
        "invoiced_info": "Ce montant peut varier selon certaines conditions.",
        "payrollSource": "Source pour le relevé d'heures",
        "name": "Nom du contrat de travail",
        "edit_name": "Modifier le nom",
        "edit_name_description": "Cela permet de différencier les contrats ou d'ajouter des informations comptables.",
        "update_error": "Une erreur est survenue lors de la mise à jour du contrat de travail.",
        "salary_daily": "%{value}/jour",
        "salary_package": "%{value}",
        "history": {
            "title": "Historique",
            "empty": "Pas d'historique pour le moment"
        },
        "legal_employer": "Employeur légal",
        "legal_employer_name": "Lift",
        "good_to_know": "Bon à savoir",
        "how_mission_work_for_clients": "Comment se déroule un contrat de travail pour un employeur?",
        "how_payroll_breakdown_works": "Comment se fait le décompte des heures de travail?",
        "how_talent_salary_is_paid": "Comment le salaire de l'employé est-il payé?",
        "what_employee_do_if_absent": "Que doit faire l'employé en cas d'absence?",
        "terminate_mission": "Résilier le contrat de travail",
        "annexes": "Annexes",
        "annexesTitle": "Annexes (%{count})",
        "important_informations": "Informations importantes",
        "informations": {
            "essential_informations": {
                "title": "Informations essentielles",
                "description": "Lift est votre partenaire administratif.\nVous signez un contrat avec {{legalEmployerName}}, qui agit en tant qu'employeur formel, tandis que vous gérez librement l’activité quotidienne de votre collaborateur.\nConcrètement, vous validez les heures travaillées et réglez la facture de Lift, nous nous occupons du reste, jusqu’au versement du salaire.\nDe son côté, votre collaborateur profite d’une couverture complète : assurances maladie et accidents et prévoyance."
            },
            "payment_deadline": {
                "title": "Échéance de paiement",
                "description": "Au milieu du mois, nous vous demandons de compléter et de valider le décompte des heures travaillées. Vous recevez ensuite notre facture. Une fois celle-ci réglée, nous versons son salaire à votre collaborateur. Afin d’assurer un traitement fluide, des frais peuvent s’appliquer en cas de paiement tardif."
            },
            "fees": {
                "title": "Frais",
                "description": "19.– par fiche de paie et par mois, au frais de l'employeur (hors TVA)"
            }
        },
        "i_agree": "Je confirme avoir lu les informations importantes et vérifié le contenu du récapitulatif de cette page",
        "annexesTag": {
            "zero": "Votre employeur a inséré {{count}} annexe",
            "one": "Votre employeur a inséré {{count}} annexe",
            "other": "Votre employeur a inséré {{count}} annexes"
        },
        "existing_avenant": {
            "title": "Avenant existant",
            "description": "Vous ne pouvez pas modifier un avenant en cours de traitement sans l'annuler auparavant."
        },
        "edit": {
            "title": "Modification de contrat",
            "salary": {
                "title": "Modification de salaire",
                "description": "Salaire brut: {{oldGrossSalary}}\nMontant facturé: {{oldInvoiceSalary}}",
                "application_date": "Date d'application",
                "min_salary_info": "Le salaire horaire brut minimum est de {{amount}}.",
                "same_salary_error": "Le montant saisi est identique au montant actuel du contrat.",
                "select_apply_date": "Veuillez sélectionner la date d’entrée en vigueur du changement de salaire.",
                "invalid_date": {
                    "title": "Date invalide",
                    "description": "Le changement ne peut entrer en vigueur car le contrat se termine le {{endDate}}."
                }
            },
            "duration": {
                "title": "Prolongation de contrat",
                "initialEndDateDescription": "Fin de contrat initiale: {{initialEndDate}}",
                "description": "Le changement prendra effet une fois que les [trois parties](intercom://11087809) auront signé l’avenant.",
                "newEndDate": "Nouvelle date de fin"
            },
            "description": "Merci d'indiquer les changements à effectuer dans le contrat.",
            "sign": "Signer l'avenant"
        },
        "mission_edit": "Modifier le contrat",
        "edit_blocked": "Modification bloquée",
        "edit_blocked_description": "Le contrat a déjà commencé et n’a pas encore été signé par l’employé. La modification est donc bloquée.",
        "mission_duplicate": "Créer un contrat à partir de celui-ci",
        "amendment": {
            "title": "Avenant au contrat actuel",
            "awaiting_application_title": "Avenant en attente d'être appliqué",
            "awaiting_application_description": "Un avenant a déjà été accepté pour ce contrat et sera appliqué le {{applyDate}}. Vous ne pouvez donc plus modifier le contrat jusqu'à cette date."
        }
    },
    "time_sheet": {
        "hours_review": "Récapitulatif des heures",
        "absences": "Absences",
        "title_same_year": "Semaine #%{week}",
        "title_other_year": "Semaine #%{week} %{year}",
        "nav_title": "Fiche horaire",
        "hours_completed": {
            "zero": "Aucune heure complétée",
            "one": "1 heure complétée",
            "other": "%{hours} complétées"
        },
        "percent_hours": "Heures à %{percent}%",
        "non_payed_hours": "Non rémunérées",
        "total_hours": "Heures totales",
        "total_working": "Total travaillé",
        "total_absence": "Total absences",
        "overtime_info": "Il y a un total de %{overtime} supplémentaires par rapport au temps de travail fixé dans le contrat de travail.",
        "submitted_info": "Envoyé le %{when}",
        "accepted_info": "Acceptée le %{when}",
        "rejected_info": "Contestée le %{when}",
        "snackbar": {
            "reject": "Fiche horaire contestée",
            "accept": "Fiche horaire acceptée"
        },
        "empty": "Dès que vous commencerez une activité pour laquelle vous devez saisir vos heures, vous pourrez les enregistrer ici.",
        "declared_inactive": "Déclaré inactif",
        "complete_timesheet_request": "Compléter la fiche horaire",
        "change_timesheet_request": "Modifier la fiche horaire",
        "undertime_info": "Vous avez %{overtime} en moins par rapport au temps de travail fixé dans le contrat de travail.",
        "nav_sub_title": "Semaine #%{week} (%{range})",
        "vacation_available": "Vacances disponibles: {{value}}",
        "no_vacation_available": "Aucunes vacances disponibles",
        "empty_external_ts": "Vos contrats prévoient une saisie des heures en dehors de Lift. Aucune fiche horaire n'est donc disponible dans l'application."
    },
    "timesheet_list": {
        "title": "Fiches horaires",
        "empty": "Vous n'avez pas encore de fiches horaires."
    },
    "camera": "Appareil photo",
    "library": "Librairie",
    "storage": "Fichiers",
    "components": {
        "address": {
            "close": "Annuler"
        },
        "select_input": {
            "close": "Annuler"
        },
        "document": {
            "title_label": "nom du document",
            "title_placeholder": "Nommer le document",
            "remove": "Supprimer",
            "share": "Partager",
            "remove_document_title": "Supprimer le document",
            "remove_document_description": "Êtes-vous sûr de vouloir supprimer ce document?",
            "remove_document_confirm": "Oui, supprimer",
            "remove_document_cancel": "Non, annuler",
            "view_inline_content": "Écrire une note",
            "inline_content_label": "Note",
            "preview_unavailable": "Prévisualisation non disponible"
        }
    },
    "createMissionManager": {
        "create_mission_failed": "Une erreur s'est produite lors de la création du contrat de travail. Si le problème persiste, contactez l'assistance.",
        "update_mission_failed": "Une erreur s'est produite lors de la mise à jour du contrat de travail. Si le problème persiste, contactez l'assistance.",
        "close_alert_title": "Supprimer le contrat de travail",
        "close_alert_description": "Les données du contrat seront perdues. Êtes-vous sûr de vouloir continuer?",
        "close_alert_cancel": "Annuler",
        "close_alert_confirm": "Effacer le contrat de travail",
        "close_alert_title_test_worker": "Supprimer la simulation",
        "close_alert_description_test_worker": "Êtes-vous sûr de vouloir continuer?",
        "close_alert_confirm_test_worker": "Effacer la simulation",
        "close_alert_title_update": "Annuler la modification de contrat",
        "close_alert_description_update": "Êtes-vous sûr de vouloir annuler les modifications apportées ? Les nouvelles données du contrat seront perdues.",
        "close_alert_confirm_update": "Annuler les modifications"
    },
    "utils": {
        "mon": "lundi",
        "tue": "mardi",
        "wed": "mercredi",
        "thu": "jeudi",
        "fri": "vendredi",
        "sat": "samedi",
        "sun": "dimanche",
        "period": "%{fromDate} au %{toDate}",
        "duration": "Durée",
        "documents": "Documents",
        "upload_document": "Ajouter un document",
        "working_time": {
            "invalid": "Horaires non valides",
            "per_week_value": "{{hours}} par semaine",
            "classic": {
                "title": "Temps de travail",
                "modes": {
                    "timePerWeek": "Durée",
                    "percent": "Pourcentage"
                },
                "nb_hours": {
                    "zero": "Aucune heure",
                    "one": "{{count}} heure",
                    "other": "{{count}} heures"
                },
                "nb_days": {
                    "zero": "Aucun jour",
                    "one": "{{count}} jour",
                    "other": "{{count}} jours"
                },
                "nb_weeks": {
                    "zero": "Aucun jour",
                    "one": "{{count}} jour",
                    "other": "{{count}} jours"
                },
                "repeat_days": {
                    "zero": "jour",
                    "one": "chaque jour",
                    "other": "tous les {{count}} jours"
                },
                "repeat_week": {
                    "zero": "semaine",
                    "one": "par semaine",
                    "other": "toutes les {{count}} semaines"
                },
                "repeat_month": {
                    "zero": "mois",
                    "one": "par mois",
                    "other": "tous les {{count}} mois"
                },
                "error": {
                    "unit_count_not_set": "Veuillez définir un temps de travail.",
                    "unit_count_too_high": "Le temps de travail ne peut pas être supérieur à {{count}} heures.",
                    "repetition_not_set": "Veuillez définir la fréquence.",
                    "daily_hours_not_set": "Veuillez définir le nombre d'heures par jour.",
                    "daily_unit_count_too_high": "Le nombre max. de jours est de {{count}} jours.",
                    "daily_hours_too_high": "Le nombre max. d'heures par jour est de {{count}} heures.",
                    "days_unit_count_too_high": "Le nombre max. de jours est de {{count}} jours.",
                    "hours_unit_count_too_high": "Le temps de travail ne peut pas être supérieur à {{count}} heures."
                },
                "repeat_none": "au total"
            },
            "specific": {
                "title": "{\"zero\":\"\",\"one\":\"Jour travaill\\u00e9\",\"other\":\"Jours travaill\\u00e9s\"}",
                "info": {
                    "zero": "Aucune date",
                    "one": "{{date}}",
                    "other": "{{count}} dates"
                }
            },
            "schedule": {
                "title": "{\"zero\":\"\",\"one\":\"Jour travaill\\u00e9\",\"other\":\"Jours travaill\\u00e9s\"}",
                "modes": {
                    "free": "Durée",
                    "fixed": "Plage horaire"
                },
                "duration_per_week": "%{duration} par semaine",
                "no_day_selected": "Veuillez sélectionner au moins un jour.",
                "free_duration_error": "La durée ne peut pas être inférieure à une heure."
            },
            "repetition_info": "Définissez la fréquence de travail",
            "hours_info": "Indiquez le nombre d'heures",
            "hours_label": "Nombre d'heures",
            "repetition": {
                "week": "Hebdomadaire",
                "month": "Mensuelle",
                "week2": "Toutes les 2 semaines",
                "week3": "Toutes les 3 semaines",
                "week4": "Toutes les 4 semaines"
            },
            "percent_label": "Taux d'activité",
            "units": "Unité",
            "repetition_for_hourly": {
                "week": "Toutes les semaines",
                "month": "Tous les mois",
                "week2": "Toutes les 2 semaines",
                "week3": "Toutes les 3 semaines",
                "week4": "Toutes les 4 semaines",
                "none": "Nombre total d'heures"
            },
            "repetition_for_daily": {
                "week": "Toutes les semaines",
                "month": "Tous les mois",
                "week2": "Toutes les 2 semaines",
                "week3": "Toutes les 3 semaines",
                "week4": "Toutes les 4 semaines",
                "none": "Nombre total de jours"
            },
            "daily_hours": "{{count}} heures par jour",
            "daily_hours_question": "Combien d'heures correspondent à une journée de travail?",
            "repetition_label": "Fréquence",
            "days_label": "Nombre de jours",
            "daily_hours_label": "Heures par jour",
            "repetition_info_daily": "Définissez la fréquence de travail",
            "repetition_info_hourly": "Définissez la fréquence de travail",
            "repetition_label_daily": "Fréquence",
            "repetition_label_hourly": "Fréquence",
            "recurrent": "Récurrent",
            "punctual": "Ponctuel",
            "on_demand": {
                "option": "Sur appel",
                "info": "Contrat de travail sur appel improprement dit : aucun volume de travail n'est garanti et le salarié est libre d'accepter ou de refuser chaque intervention proposée.",
                "summary": "Sur appel – aucun volume de travail garanti"
            },
            "days_info": {
                "none": "Indiquez le nombre de jours de travail",
                "week": "Indiquez le nombre de jours de travail par semaine",
                "week2": "Indiquez le nombre de jours de travail toutes les 2 semaines",
                "week3": "Indiquez le nombre de jours de travail toutes les 3 semaines",
                "week4": "Indiquez le nombre de jours de travail toutes les 4 semaines",
                "month": "Indiquez le nombre de jours de travail par mois"
            },
            "monthly_hours_or_percent": "Indiquez le taux d'activité ou le nombre d'heures"
        },
        "on": "le",
        "from": "du"
    },
    "workingTime": {
        "addScheduleSlot": "Ajouter une plage horaire",
        "removeScheduleSlot": "Supprimer",
        "addDate": "Ajouter une date",
        "removeDate": "Supprimer cette date",
        "cloneDate": "Dupliquer les plages de cette date",
        "genericError": "Une erreur s'est produite.",
        "overlapError": "Les plages horaires se chevauchent.",
        "invalidTime": "Les plages horaires ne sont pas valides.",
        "emptyDuration": "La durée ne peut pas être vide.",
        "emptyTimes": "Les plages horaires ne peuvent pas être vides.",
        "repetition": {
            "day": "Tous les jours",
            "week": "Toutes les semaines",
            "month": "Tous les mois",
            "week2": "Toutes les 2 semaines",
            "week3": "Toutes les 3 semaines",
            "week4": "Toutes les 4 semaines"
        },
        "unit": {
            "days": "jour(s)",
            "weeks": "semaine(s)",
            "hours": "heure(s)"
        },
        "type": {
            "work": "Travail",
            "public_holiday": "Jour férié",
            "vacation": "Vacances",
            "military": "Service militaire",
            "sickness": "Maladie",
            "accident": "Accident",
            "maternity": "Maternité/Paternité",
            "trainee": "Formation",
            "sickness_close_relative": "Maladie d'un proche",
            "death_close_relative": "Décès d'un proche",
            "marriage": "Mariage",
            "moving": "Déménagement",
            "other": "Autre"
        },
        "date_already_added": "Cette date a déjà été ajoutée.",
        "hours_by_week": "heures/semaine",
        "tooLowDuration": "La durée ne peut pas être inférieure à une minute.",
        "dropdown_show_intercom": "En savoir plus sur les types d'absence",
        "insufficient_vacation": "Solde de vacances insuffisant",
        "insufficient_vacation_info": "Solde de vacances insuffisant. {{value}} de vacances reportée(s) en trop."
    },
    "screens": {
        "contract_signing": {
            "title": "Signature du contrat",
            "start": "Commencer le processus",
            "back": "Retour",
            "go_home": "Retour à l'accueil",
            "server_error": "La vérification de votre identité a malheureusement échoué.\n\nSi le problème persiste, contactez l'assistance.",
            "description": "Nous allons vous accompagner tout au long du processus de signature électronique de votre contrat de travail.\n\nLa première étape implique une vérification de votre identité. Pour ce faire, vous aurez besoin de votre passeport ou de votre carte d’identité suisse. Cette étape est traitée de manière sûre et confidentielle.",
            "browser_closed": "Le navigateur a été fermé. Vous pouvez reprendre le processus en cliquant sur le bouton ci-dessous.",
            "contact_support": "Contacter l'assistance",
            "reset_signing": "Ré-essayer",
            "reset_error": "Une erreur s'est produite lors de la réinitialisation du processus de signature. Si le problème persiste, contactez l'assistance.",
            "state_message": {
                "ident_processing": "La vérification de votre identité est en cours, vous serez informé dès qu'elle sera terminée.",
                "ident_failed": "La vérification d'identité a échoué ou le processus a été interrompu. Pouvez-vous réessayer?\n\nSi le problème persiste, veuillez contacter l'assistance.",
                "sign_processing": "La signature du contrat est en cours, vous serez informé dès qu'elle sera terminée.",
                "sign_failed": "La signature du contrat a échoué, veuillez contacter l'assistance.",
                "sign_rejected": "Malheureusement, la signature du contrat a été refusée et le contrat a donc été annulé.",
                "sign_success": "Le contrat a été signé avec succès.",
                "email_sent": "Un e-mail vous indiquant la procédure de signature vous a été envoyé à %{email}.",
                "sign_declined": "La signature du contrat a été refusée.",
                "sign_withdrawn": "La signature du contrat a été annulée.",
                "sign_canceled": "Êtes-vous certain de vouloir interrompre la signature du contrat?"
            },
            "congratulations": "Félicitations!",
            "back_to_mission": "Retour au contrat de travail",
            "sign_location_contract": "signe le contrat de location",
            "sign_work_contract": "signe le contrat de travail",
            "validate_signed_contracts": "valide les contrats signés",
            "loading": "Préparation du document pour la signature électronique. Merci de patienter un instant.",
            "retry_signing": "Retour à la signature",
            "postpone_signing": "Signer plus tard",
            "signing_error": "Une erreur est survenue lors de la signature du contrat.",
            "you_signed_the_contract_client": "Vous avez signé le contrat de location de services et la proposition de contrat de travail a été envoyée à %{name}.\n\nDès que l'employé l'aura signé à son tour, Lift validera les contrats des deux parties.",
            "you_signed_the_contract_worker": "Vous avez bien signé le contrat de travail.\n\nC'est à présent au tour de Lift de le signer afin qu'il soit validé.",
            "signing_success_client": "Contrat signé!\nLes contrats sont maintenant en cours de validation chez Lift.",
            "signing_success_worker": "Contrat signé!",
            "amendment_signing_success_client": "Merci d'avoir signé l'avenant.\nC'est au tour de l'employé de le signer à présent.",
            "amendment_signing_success_worker": "Avenant signé!\nL'avenant est maintenant en cours de validation chez Lift.",
            "signature_status_update": {
                "contract": {
                    "client": {
                        "success": "Contrat signé!\nLes contrats sont maintenant en cours de validation chez Lift.",
                        "decline": "Le contrat a été refusé."
                    },
                    "worker": {
                        "success": "Contrat signé!",
                        "decline": "Le contrat a été refusé."
                    }
                },
                "amendment": {
                    "client": {
                        "success": "Merci d'avoir signé l'avenant.\nC'est au tour de l'employé de le signer à présent.",
                        "decline": "L'avenant a été refusé."
                    },
                    "worker": {
                        "success": "Avenant signé!\nL'avenant est maintenant en cours de validation chez Lift.",
                        "decline": "L'avenant a été refusé."
                    }
                },
                "client_framework": {
                    "client": {
                        "success": "Le contrat de co-emploi a été signé. Vous pouvez à présent signer des contrats de travail.",
                        "decline": "Le contrat de co-emploi a été refusé. Notre équipe vous contactera prochainement."
                    }
                }
            },
            "finalizing": "Finalisation de la signature en cours.",
            "finalization_pending": "La finalisation du contrat est toujours en cours. Vous pouvez continuer à utiliser l'application.",
            "session_creation_error": "Une erreur est survenue car le serveur ne répond pas. Veuillez réessayer.",
            "retry": "Réessayer"
        },
        "client_list": {
            "title": "Mes employeurs"
        },
        "auth": {
            "welcome": {
                "subTitle": "Votre compagnon de vie professionnelle",
                "what_is_basquiat": "Lift, c'est quoi?",
                "intro_title": "La nouvelle devise du travail",
                "intro_text": "Lift permet à tout le monde de recruter sans avoir à gérer les contraintes administratives liées à l’embauche.\n\nDe plus, Lift permet à tout employé de bénéficier d’une protection individualisée, tout en garantissant un salaire minimum et en proposant un outil de gestion pour de multiples sources de revenus.\n\nSimplifiez vos démarches, maximisez vos opportunités!",
                "basquiat_for_a": "Lift pour un ",
                "client_intro_text": "Nous engageons, déclarons et rémunérons l'employé, en toute simplicité, pour votre compte.",
                "client_check_item_1": "Processus d’embauche rapide et simple",
                "client_check_item_2": "Prise en charge des processus liés à la gestion du personnel",
                "client_check_item_3": "Réduction des risques de non-conformité",
                "client_check_item_4": "Davantage de flexibilité et de réactivité",
                "client_check_item_5": "Dès un contrat d’une heure",
                "worker_intro_text": "Lift permet aux employés de mieux maîtriser leurs revenus et d’améliorer leur protection et leur prévoyance sociales.",
                "worker_check_item_1": "Garantie d’un salaire payé en temps et en heure",
                "worker_check_item_2": "Gestion centralisée de multiples sources de revenus",
                "worker_check_item_3": "Obtention de fiches de salaire et accès au chômage",
                "worker_check_item_4": "Protection sociale renforcée et planification simplifiée de votre retraite (2025)",
                "worker_check_item_5": "Dès un contrat d’une heure",
                "worker": "Employé",
                "client": "Employeur",
                "start": "commencer",
                "intro_lift_employee": "Employé Lift, prestataire",
                "intro_portage_company": "Société de portage salarial",
                "intro_lift_company": "Client Lift, locataire de services",
                "company": "Entreprise",
                "scan_qr_code": "Scannez le QR code pour accéder à l’application mobile **Apple** ou **Android**",
                "start_new_adventure": "Démarrez votre nouvelle aventure ici!",
                "download_app": "Téléchargez l’app pour une meilleure expérience",
                "our_partners": "Nous avançons avec",
                "login": "Se connecter",
                "signup": "S'inscrire",
                "connect": "Connexion",
                "a_personn": "Une personne",
                "invite": "{{invitedBy}} vous invite à rejoindre Lift"
            },
            "screen_card": {
                "validation_button_title": "Validation"
            },
            "phone_number": {
                "title": "Code d'activation",
                "description": "Veuillez entrer votre numéro de téléphone.\n\nNous vous enverrons ensuite un code de confirmation qui vous permettra d’accéder à votre compte.",
                "phone_label": "Téléphone",
                "phone_placeholder": "Numéro de téléphone",
                "invalid_number": "Ce numéro de téléphone n'est pas valide.",
                "next_button_title": "Continuer",
                "missing_phone_number": "Veuillez entrer votre numéro de téléphone.",
                "quota_exceeded": "Le service SMS est actuellement saturé. Veuillez réessayer dans un moment ou contacter l’assistance si le problème persiste.",
                "too_many_requests": "Une activité inhabituelle a été détectée, signalant un abus possible ou une utilisation non conforme du service. Veuillez réessayer plus tard ou contacter l’assistance si le problème persiste.",
                "user_disabled": "Ce numéro a été désactivé par Lift et ne peut donc plus être utilisé.",
                "operation_not_allowed": "Connexion temporairement indisponible. Nous travaillons à résoudre le problème. Veuillez réessayer plus tard ou contacter l’assistance si nécessaire.",
                "description_signup": "Veuillez entrer votre numéro de téléphone. Celui-ci vous servira d’identifiant.\n\nNous vous enverrons un code d’activation afin de garantir que vous êtes la seule personne à pouvoir accéder à votre compte.",
                "description_web": "Entrez votre numéro de téléphone pour débuter votre inscription.\n\nVous recevrez ensuite un code de confirmation qui vous permettra de valider votre numéro."
            },
            "confirmation_code": {
                "title": "Saisissez le code de validation",
                "description": "Merci de saisir le code que nous vous avons envoyé au {{phoneNumber}}.",
                "wrong_code": "Le code n'est pas valide"
            },
            "select_role": {
                "title": "Votre rôle",
                "description": "Quel profil voulez-vous créer?",
                "client": "Employeur entreprise",
                "worker": "Employé",
                "private_client": "Employeur domestique",
                "no_account": "Aucun compte n’est associé à ce numéro.\nVeuillez en créer un pour commencer."
            },
            "invitation_code": {
                "title": "Code d'invitation",
                "description": "Vous avez reçu une invitation par e-mail ? Saisissez le code qu'elle contient.",
                "placeholder": "Ex. : K7P2-XQ9M",
                "submit": "Continuer",
                "skip": "Je n'ai pas de code",
                "errors": {
                    "invitation_code_not_found": "Ce code ne correspond à aucune invitation. Vérifiez-le et réessayez.",
                    "invitation_code_already_used": "Cette invitation a déjà été utilisée.",
                    "invitation_code_expired": "Cette invitation a expiré. Demandez à la personne qui vous a invité de vous en envoyer une nouvelle.",
                    "already_member": "Vous faites déjà partie de cette entreprise.",
                    "account_required": "Créez d'abord votre compte : le code vous sera demandé pendant l'inscription.",
                    "generic": "Le code n'a pas pu être vérifié. Veuillez réessayer."
                }
            },
            "password": {
                "title": "Saisir un e-mail et un mot de passe",
                "description": "Il vous permettra d’accéder à votre compte et de valider des actions importantes.",
                "email_label": "e-mail",
                "email_password": "mot de passe"
            },
            "smile": {
                "title": "Souriez!",
                "description": "Envoyez-nous une photo de vous",
                "upload_button": "Choisir"
            },
            "notifications": {
                "title": "Notifications",
                "sub_title": "Restez informé!",
                "description": "Assurez-vous d'accepter les notifications afin de ne pas manquer d'informations importantes relatives à vos fiches horaires ou à de nouvelles propositions de contrat par exemple.",
                "access_app_settings": "Accéder aux paramètres",
                "permission_rejected": "Permission refusée",
                "permission_authorized": "Notifications activées"
            },
            "upgrade_worker": {
                "title": "Oups! Nous devons migrer votre compte.",
                "upgrade_button": "Migrer mon compte"
            },
            "identity": {
                "title": "Identité",
                "description": "Veuillez photographier l'un des documents suivants pour la vérification d'identité:",
                "swiss_id_card": "Carte d'identité suisse",
                "swiss_passport": "Passeport suisse",
                "valid_work_permit": "Permis de travail C, B, G, L"
            },
            "scanId": {
                "front": "Recto",
                "back": "Verso",
                "capture_face_with_photo": "Scannez le recto de votre document.",
                "capture_back_of_document": "Scannez le verso de votre document.",
                "capture_page_with_photo": "Scannez la page où figure votre photo.",
                "unknown_error": "Erreur de serveur. Merci de réessayer."
            },
            "usageAndPrivacy": {
                "title": "Utilisation et confidentialité",
                "retake_photos": "Reprendre les photos",
                "accept_terms_of_use": "J'ai lu et j'accepte les [conditions d’utilisation de Lift](intercom://8895605).",
                "accept_privacy_policy": "J'ai lu et j'accepte la [politique de confidentialité de Lift](intercom://8460851).",
                "next": "Continuer"
            },
            "signup": {
                "incomplete_data": "L'inscription est impossible car certaines données sont incomplètes.",
                "unknown_error": "Erreur lors de l'inscription",
                "data_sent": "Informations envoyées"
            },
            "idVerificationPending": {
                "asClient": "qu'employeur",
                "asTalent": "qu'employé",
                "description": "Nous vérifions votre demande d’inscription. Cela peut prendre jusqu’à 1 minute.",
                "soon": "On se réjouit de vous accueillir sur Lift!",
                "title": "Vérification d'identité en cours"
            },
            "idVerificationRetry": {
                "description": "Malheureusement, la vérification d’identité a échoué pour la raison suivante:",
                "nextButton": "Recommencer",
                "title": "La vérification d'identité a échoué",
                "veriffCodes": {
                    "101": "Document physique non reconnu",
                    "102": "Suspicion de falsification du document",
                    "103": "Incohérence entre la personne et la photo du document",
                    "105": "Comportement suspect",
                    "106": "Fraude identifiée",
                    "108": "Activité suspecte détectée pour cet utilisateur",
                    "109": "Activité suspecte détectée depuis cet appareil",
                    "110": "Activité suspecte détectée avec cette pièce d’identité",
                    "112": "Connexion depuis une localisation non autorisée",
                    "113": "Activité suspecte: utilisation abusive d’identités",
                    "120": "La photo ne correspond pas à l’image de référence",
                    "121": "Identifiant utilisateur manquant",
                    "122": "Aucune référence trouvée",
                    "123": "Impossible de valider les informations dans les registres officiels",
                    "126": "Correspondance potentielle avec une personne politiquement exposée (PPE)",
                    "127": "Correspondance faciale avec une liste de blocage",
                    "502": "Présences multiples détectées en session",
                    "503": "Tentative de fraude détectée",
                    "504": "Les documents pris en photos sur un écran ne sont pas reconnus.",
                    "505": "Tentative de fraude détectée – utilisation d'un document imprimé",
                    "507": "Document falsifié – anomalies détectées au recoupement des données",
                    "508": "Document falsifié – similitudes avec un modèle de référence connu",
                    "509": "La personne ne correspond pas à la photo sur le document présenté",
                    "510": "Type de document non reconnu",
                    "511": "Document expiré",
                    "515": "Tentative de fraude détectée – l'image provient d'un écran et non d'une personne réelle",
                    "526": "Tentative de fraude détectée – photos diffusée",
                    "527": "Impossible de récupérer les informations du justificatif de domicile",
                    "528": "Justificatif de domicile expiré",
                    "530": "La personne a moins de 13 ans",
                    "531": "La personne a moins de 14 ans",
                    "532": "La personne a moins de 16 ans",
                    "533": "La personne a moins de 18 ans",
                    "534": "La personne a moins de 20 ans",
                    "535": "La personne a moins de 21 ans",
                    "536": "La personne a moins de 25 ans",
                    "537": "Échec recadrage portrait du document",
                    "539": "Nombre maximum de tentatives dépassé",
                    "540": "Niveau de fiabilité de la session insuffisant"
                }
            },
            "verificationFailed": {
                "description": "Malheureusement, la vérification d’identité a échoué.\n\nVotre demande ne remplit pas les [conditions requises pour l’utilisation de nos services](intercom://8895605). Contactez-nous à l’aide du bouton ci-dessous pour que nous puissions vous aider.",
                "delete_profile": "Supprimer ce profil",
                "delete_account": "Supprimer mon compte",
                "title": "Échec de la vérification d’identité"
            },
            "check_client_info": {
                "title": "Profil employeur",
                "intro": "L’employeur doit être titulaire d’un passeport/carte d’identité suisse ou d’un permis de travail suisse valide (C, B, G, L, S).",
                "civility_placeholder": "Civilité",
                "email_label": "E-mail professionnel",
                "import_company_logo": "Importer le logo de l'entreprise",
                "company_name_label": "Nom de l'entreprise",
                "company_address_label": "Adresse de l'entreprise",
                "allowed_to_hire": "Je suis autorisé à recourir à des employés pour mon compte ou celui de l'entreprise.",
                "terms_text": "1. Introduction\nLes présentes conditions d’utilisation (les \"Conditions\") encadrent l’utilisation de l’application mobile (\"l’Application\") développée par Basquiat SA (\"Nous\", \"Notre\" ou \"Nos\"). En accédant à l’Application ou en l’utilisant, vous reconnaissez avoir pris connaissance des présentes Conditions et les accepter sans réserve.\n\n2. Utilisation de l'Application\nVous vous engagez à utiliser l’Application exclusivement à des fins légales et conformément aux présentes Conditions.\nIl est strictement interdit d’utiliser l’Application:\na. d’une manière contraire aux lois et réglementations applicables;\nb. d’une manière susceptible de porter atteinte aux droits, aux intérêts ou à la réputation de Notre entreprise ou de tiers;\nc. d’une manière qui pourrait perturber, entraver ou compromettre l’accès, l’utilisation ou le bon fonctionnement de l’Application.\n\n3. Services externes\nL’Application fait appel à des services externes fournis par des tiers afin d’offrir l’ensemble de ses fonctionnalités. En utilisant l’Application, vous reconnaissez et acceptez le recours à ces services tiers, ainsi que le fait que les données que vous leur fournissez sont traitées conformément à leurs propres politiques de confidentialité.\n\n4. LPD/GDPR\nNous nous engageons à protéger vos données personnelles conformément au Règlement général sur la protection des données (RGPD). En utilisant l’Application, vous reconnaissez et acceptez que Nous recueillions, conservions et traitions vos données personnelles conformément à Notre politique de confidentialité.\n\n5. Utilisation des cookies\nL’Application utilise des cookies afin d’améliorer votre expérience utilisateur et de collecter des informations relatives à votre utilisation de l’Application. En utilisant l’Application, vous acceptez l’utilisation de cookies conformément à Notre politique de cookies.",
                "fill_all_fields": "Veuillez remplir tous les champs.",
                "accept_terms_of_use": "J'accepte les [conditions d’utilisation](intercom://8895605) et la [politique de confidentialité](intercom://8460851) de Lift.",
                "error": "Une erreur est survenue lors de l'enregistrement des données.",
                "first_name_label": "Prénom",
                "last_name_label": "Nom",
                "can_sign_contracts_label": "Êtes-vous habilité à signer des contrats de travail pour le compte de l'entreprise?"
            },
            "check_worker_info": {
                "title": "Inscription",
                "intro": "L'employé doit avoir 18 ans révolus et être titulaire d'une pièce d'identité suisse ou de l'UE ou d'un permis de travail suisse valide (C, B, G, L ou S).",
                "residential_address": "Adresse de domicile",
                "accept_terms_of_use": "J'accepte les [conditions d’utilisation](intercom://8895605) et la [politique de confidentialité](intercom://8460851) de Lift.",
                "has_permit": "Êtes-vous suisse ou avez-vous un permis de travail suisse valide?"
            },
            "preIdVerification": {
                "title": "Vérification d'identité",
                "description": "Cette étape est essentielle pour sécuriser votre compte et vous permettre de signer des contrats en toute confidentialité.",
                "nextButton": "Allons-y!",
                "description_swiss_or_permit": "Cette étape est essentielle pour sécuriser votre compte et vous permettre de signer des contrats en toute confidentialité.\n\nVeuillez vous munir de votre passeport/carte d'identité suisse ou d'un permis suisse valide (C, B, G, L ou S).",
                "description_no_permit": "Cette étape est essentielle pour sécuriser votre compte et vous permettre de signer des contrats en toute confidentialité.\n\nVeuillez vous munir de votre pièce d'identité de l'UE/AELE pour procéder à la vérification.",
                "description_client": "Cette étape est essentielle pour sécuriser votre compte et vous permettre de signer des contrats en toute confidentialité.\n\nVeuillez vous munir d'un des documents suivants:\n- Passeport suisse ou de l'UE/AELE\n- Carte d'identité suisse ou de l'UE/AELE\n- Permis de séjour suisse (C, B, G, L ou S)",
                "skipButton": "Plus tard"
            },
            "signupFinished": {
                "title": "Bienvenue {{name}}!",
                "sub_title": "Le monde de Lift vous ouvre ses portes!",
                "description_client": "Vous pouvez dès à présent créer des contrats de travail et engager des employés.",
                "description_worker": "Une fois qu'un employeur vous aura envoyé une proposition, vous pourrez signer votre contrat et profiter des nombreux avantages de Lift.",
                "nextButton": "Allons-y!"
            },
            "postOnboarding": {
                "title": "Félicitations!",
                "sub_title": "Votre identité a été validée",
                "description": "Veuillez compléter votre profil afin de pouvoir générer des contrats de travail.",
                "nextButton": "C'est parti!"
            },
            "clientVerificationPending": {
                "description": "Nous avons bien reçu votre demande d’inscription et vous informerons dès que votre compte aura été vérifié (72h max.)",
                "title": "Vérification de votre entreprise en cours",
                "in_the_meantime_check_articles": "En attendant, voici quelques articles qui vous seront utiles.",
                "how_to_create_mission": "Comment créer un contrat de travail?",
                "how_mission_work_for_clients": "Comment se déroule un contrat de travail pour un employeur?",
                "can_transfer_current_employees": "Puis-je transférer mes employés actuels chez Lift?",
                "how_payroll_breakdown_works": "Comment se fait le décompte des heures de travail?",
                "how_talent_salary_is_paid": "Comment le salaire de l'employé est-il payé?"
            },
            "check_private_client_info": {
                "title": "Inscription",
                "intro": "L'employeur domestique doit avoir 18 ans révolus et disposer d'une pièce d'identité suisse ou de l'UE ou d'un permis de travail suisse valide (C, B, G, L, S).",
                "residential_address": "Adresse de domicile",
                "accept_terms_of_use": "J'accepte les [conditions d’utilisation](intercom://8895605) et la [politique de confidentialité](intercom://8460851) de Lift.",
                "error": "Une erreur est survenue lors de l'enregistrement des données."
            },
            "privateClientVerificationPending": {
                "title": "Vérification en cours",
                "description": "Nous finalisons la vérification de votre nouveau profil. Cela peut prendre jusqu’à 72h."
            },
            "idVerificationFailed": {
                "title": "La vérification d'identité a échoué",
                "description": "Argh! Votre demande d’identification a échoué: elle ne remplit pas les [conditions requises pour l’utilisation de nos services](intercom://8895605). Veuillez contacter l'assistance pour que nous puissions vous aider.",
                "nextButton": "Assistance"
            },
            "clientVerificationFailed": {
                "title": "La vérification de votre entreprise a échoué",
                "description": "Votre entreprise n’a malheureusement pas été acceptée: elle ne remplit pas les [conditions requises pour l’utilisation de nos services](intercom://8895605). Veuillez contacter l'assistance pour que nous puissions vous aider dans vos démarches.",
                "delete_profile": "Supprimer ce profil",
                "delete_account": "Supprimer mon compte"
            },
            "privateClientVerificationFailed": {
                "title": "Vérification échouée",
                "description": "Malheureusement, votre demande d'identification a été refusée, car elle ne remplit pas les [conditions requises pour l’utilisation de nos services](intercom://8895605).",
                "delete_profile": "Supprimer ce profil",
                "delete_account": "Supprimer mon compte"
            },
            "presentation_carousel": {
                "your_professional_companion": "Votre compagnon professionnel",
                "companion_text": "**Lift est une solution d’embauche** qui gère les aspects liés aux salaires, aux assurances et aux cotisations sociales.",
                "transparent_relationship": "Une relation transparente et durable",
                "transparent_text": "En simplifiant la relation entre employeur et employé, Lift vous permet de vous concentrer sur l’essentiel: **la relation de travail.**",
                "simple_as_hello": "Simple comme bonjour",
                "simple_text": "Employeurs et employés gagnent en **agilité** tout en renforçant leur **protection sociale.**\n\nVous travaillez ensemble, **Lift gère le reste.**",
                "our_partners": "Nous avançons avec",
                "our_partners_text": "Nous nous efforçons d’établir des partenariats fiables et solides afin d’obtenir des **résultats durables.**",
                "create_my_account": "Créer mon compte",
                "step_0": {
                    "title": "La nouvelle devise du travail"
                },
                "step_1": {
                    "title": "# Signez un contrat de travail en quelques minutes.\n\n<br><br>\n\n# Lift se charge de l'embauche et de la paie."
                },
                "step_2": {
                    "title": "## Lift prend en charge tous les aspects administratifs et juridiques",
                    "detail_1": "Création et signature de contrats en quelques clics",
                    "detail_2": "Gestion complète des salaires et des absences",
                    "detail_3": "Conformité légale et protection sociale garanties"
                },
                "step_3": {
                    "title": "## Une plateforme innovante et accessible à tous",
                    "clients": "Employeurs",
                    "clients_description": "Lift gère tous les aspects administratifs et juridiques pour seulement 19.– CHF par fiche de paie.",
                    "workers": "Employés",
                    "workers_description": "Lift assure votre protection sociale dès la première heure de travail: chômage, 2ᵉ pilier et bien plus."
                },
                "step_4": {
                    "title": "## Une relation tripartite simple et sécurisante",
                    "detail_1": "**L'employeur** se concentre sur la relation de travail",
                    "detail_2": "**L'employé** travaille normalement, avec Lift comme employeur légal",
                    "detail_3": "**Lift** facture le salaire à l'employeur et le verse à l'employé"
                },
                "step_5": {
                    "title": "Découvrez Lift maintenant."
                },
                "already_have_account": "Déjà inscrit? Se connecter",
                "no_account": "Pas de compte Lift? S'inscrire",
                "go_back": "Retour"
            },
            "postOnboarding_more": {
                "title": "Informations complémentaires",
                "description": "Veuillez fournir les nouvelles informations requises pour continuer à profiter de Lift:\n\n{{informations}}"
            },
            "email_verified": {
                "open_app": "Ouvrir l'application",
                "success": {
                    "title": "Email vérifié avec succès",
                    "description": "Votre adresse e-mail a été vérifiée avec succès. Vous pouvez maintenant accéder à votre compte."
                },
                "error": {
                    "title": "Erreur de vérification",
                    "description": "Une erreur s'est produite lors de la vérification de votre adresse e-mail. Veuillez réessayer ou contacter le support."
                }
            }
        },
        "post_onboarding_client_working_time": {
            "title": "Temps de travail",
            "intro": "Avant de pouvoir créer de nouveaux contrats de travail, il nous faut quelques informations sur le temps de travail hebdomadaire dans l'entreprise.",
            "description_1": "Pour information, dans la Location de services (LSE), le temps de travail hebdomadaire est de 42 heures.",
            "description_2": "La durée est généralement de 40 à 45 heures.",
            "description_3": "Cette information nous servira lors de la création de contrats de travail pour déterminer le temps de travail à 100%.",
            "invite_workers_description": "Vous devez être connecté avec au moins un employé pour pouvoir utiliser l'application."
        },
        "post_onboarding_experience": {
            "title": "Expérience",
            "intro": "Pour calculer le salaire au plus juste, il nous faut quelques informations au sujet de votre parcours:",
            "education_label": "Formation",
            "years_of_experience": "Expérience",
            "years": {
                "zero": "Aucune année",
                "one": "{{count}} année",
                "other": "{{count}} années"
            },
            "worker_category": "Catégorie de personnel",
            "join_certificates": "Merci de joindre vos certificats et attestations pour justifier de vos années d'expérience, et vos diplômes pour justifier de vos qualifications."
        },
        "client_profile": {
            "tabs": {
                "missions": {
                    "title": "Contrats"
                },
                "employees": {
                    "title": "Employés",
                    "no_workers": "Vos employés apparaitront ici.\nInvitez-les afin de leur proposer des contrats de travail.",
                    "invite_talent": "Inviter un employé",
                    "employee": "Employé",
                    "no_clients": "Vos employeurs apparaitront ici.\nInvitez-les à vous engager!",
                    "private_client": "Employeur domestique",
                    "cannot_load_workers": "Désolé, une erreur s'est produite lors du chargement."
                },
                "invoices": {
                    "title": "Factures",
                    "no_invoices": "Toutes vos factures seront visibles ici."
                },
                "invitations": {
                    "title": "Invitations"
                },
                "activities": {
                    "title": "Activités"
                },
                "help": {
                    "title": "Aide"
                },
                "profile": {
                    "title": "Profil"
                }
            }
        },
        "user": {
            "tabs": {
                "missions": "Contrats",
                "life": "Vie",
                "salaries": "Salaire",
                "invitations": "Invitations",
                "activities": "Activités",
                "time_sheets": "Heures",
                "todos": "Mes tâches",
                "invoices": "Factures"
            },
            "activities": {
                "no_activity": "Toutes les actions que vous devez effectuer apparaitront ici.",
                "activity": "Historique",
                "logs": "Journal",
                "todos": "Tâches"
            },
            "profile": {
                "title": "Mon profil",
                "header_support": "Assistance"
            },
            "missions": {
                "create_mission": "Créer un contrat de travail",
                "first_mission_label": "Créons votre premier contrat de travail ensemble!",
                "no_invites": "Les contrats de travail soumis seront listés ici.\n\nRenforcez votre protection sociale en invitant vos employeurs à vous embaucher sur Lift!",
                "no_talents": "Les contrats de travail s’afficheront ici. Pour en créer un, invitez d’abord un employé via la barre de navigation.",
                "create_mission_now": "Les contrats de travail que vous établissez apparaitront ici.",
                "cannot_load_missions": "Désolé, une erreur s'est produite lors du chargement.",
                "actions_to_do": "Vous avez plusieurs actions à entreprendre:",
                "enter_your_worktime": "saisir vos heures",
                "validate_worktime": "valider des heures",
                "validate_contract": "valider un contrat",
                "actions_to_do_end": "\n[Voir la liste complète](Notifications)",
                "need_email_validation": "Votre e-mail n'a pas encore été validé. Veuillez vérifier votre boîte de réception.\n\n[renvoyer un e-mail](#send)",
                "email_validation_sent": "Nous vous avons envoyé un e-mail à %{email}. Si le message n'apparaît pas dans votre boîte de réception, merci de vérifier vos autres dossiers (notamment votre dossier spam).",
                "read_and_sign_contract": "Vérifier et signer",
                "has_invites": "Les contrats de travail soumis seront affichés ici.\n\nVotre employeur a été notifié de votre inscription et pourra vous envoyer un contrat prochainement.",
                "create_new_mission": "Créer un nouveau contrat de travail",
                "invite_client": "Inviter un employeur",
                "invite_client_short": "Inviter",
                "sharing_not_available": "Le partage n'est pas disponible",
                "client_empty_generic_text": "Les contrats de travail que vous créez apparaitront ici.",
                "select_ijm": "Choisir mon plan IJM",
                "empty_no_ijm": "Puis, sélectionnez un plan IJM.",
                "empty_no_talent": "Commencez par inviter un employé à l'aide de la barre d’outils ci-dessous.",
                "no_talents_left": "Les contrats de travail que vous créez apparaissent ici. Pour en créer un nouveau, commencez par inviter un employé à l'aide de la barre d’outils à gauche.",
                "know_more_about_missions": "En savoir plus sur le déroulement d'un contrat de travail",
                "filters": {
                    "accepted": "En cours et signés",
                    "cancelled": "Annulées",
                    "draft": "Brouillons",
                    "ended": "Terminées",
                    "pendingAcceptation": "En attente",
                    "terminated": "Résiliées"
                },
                "multi_sign_title": "Signer plusieurs contrats",
                "multi_sign_description": "Sélectionnez les contrats en attente de signature, puis signez-les tous en une seule fois.",
                "filters_intro": "Listez uniquement les contrats que vous souhaitez voir.",
                "selection_title": {
                    "zero": "0 sélectionné",
                    "one": "%{count} sélectionné",
                    "other": "%{count} sélectionnés"
                },
                "selection_banner": "Sélectionnez les contrats en attente de votre signature",
                "multi_sign_intro": {
                    "zero": "",
                    "one": "Vous signez ce contrat. L'employé sera notifié et recevra son contrat signé.",
                    "other": "Vous signez ces %{count} contrats en une seule fois. Les employés seront notifiés et recevront leur contrat signé."
                },
                "multi_sign_section": "Contrats à signer",
                "multi_sign_progress_title": "Signature en cours...",
                "multi_sign_progress_description": "Vos contrats sont en cours de signature. Cette opération peut prendre quelques minutes.",
                "multi_sign_progress_count": "sur %{total} signés",
                "multi_sign_progress_signed": "Signé",
                "multi_sign_progress_see_more": "Voir plus",
                "multi_sign_progress_background": "**Vous pouvez continuer**\n\nVous pouvez fermer cette fenêtre à tout moment. L’opération se poursuit en arrière-plan et vous serez informé dès qu’elle sera terminée.",
                "multi_sign_progress_error": "Impossible de lancer la signature. Réessayez plus tard.",
                "sign_selected": {
                    "zero": "Signer %{count} contrat",
                    "one": "Signer %{count} contrat",
                    "other": "Signer %{count} contrats"
                },
                "multi_sign_progress_done_title": "Contrats signés",
                "multi_sign_progress_done_description": "Les employés seront notifiés et recevront leur contrat à signer une fois que Lift l'aura vérifié et signé.",
                "multi_sign_progress_done_close": "Retour à mes contrats"
            },
            "mission_onboarding": {
                "title": "Préparation pour l'activité",
                "submit": "Soumettre",
                "edit": "Modifier",
                "success": "Instructions envoyées",
                "next_button_worker": "J'en prends note.",
                "header_client": "Veuillez envoyer les informations requises à %{name} avant le début du contrat de travail.",
                "header_worker": "Le contrat de travail de %{name} va bientôt débuter. Merci de bien vouloir prendre note des informations suivantes:",
                "footer": "Ce contrat de travail est soumis à la CCT Location de services. \n\n [Lire la CCT](https://www.tempservice.ch/fr/tempdata/detail.php?cid=815001&vid=9&eid=12469#documents)",
                "documents": "Si votre entreprise a des règles ou des documents de sécurité spécifiques, vous pouvez les ajouter ici."
            },
            "mission_details_accept": {
                "title_worker": "Signez le contrat de travail.",
                "title_client": "Signez le contrat de location."
            },
            "salaries": {
                "my_salaries": "Mes salaires",
                "total_for_month": "Total pour le mois de **{{yearMonth}}**:&NewLine;&NewLine;**Salaire net de {{netSalary}}** versé sur votre compte.",
                "salary_sheet": "Fiche de salaire",
                "filename_salary": "salaire-{{month}}-{{year}}",
                "wait_salary_asset": "Nous sommes en train de télécharger votre fiche de salaire. Veuillez patienter quelques instants…",
                "no_salary": "Vos fiches de paie seront disponibles sur cette page. \nLe versement des salaires se fait le 25 de chaque mois, mais au plus tard le 5 du mois suivant.",
                "cannot_load_salaries": "Désolé, une erreur s'est produite lors du chargement.",
                "payslip_sheet": "Fiche de paie",
                "filename_payslip": "fiche-de-paie-{{mission}}-{{month}}-{{year}}",
                "payslip_count": {
                    "zero": "Aucune fiche de paie",
                    "one": "Une fiche de paie",
                    "other": "{{count}} fiches de paie"
                },
                "salaries_number": {
                    "zero": "Aucun salaire",
                    "one": "{{count}} salaire",
                    "other": "{{count}} salaires"
                }
            },
            "invoices": {
                "to_pay": "À payer",
                "paid": "Déjà payées",
                "paid_status": "Payée",
                "to_pay_cta": "Payer la facture",
                "everything_have_been_paid": "Félicitations, tout a été payé!",
                "invoice": "Facture",
                "invoice_token": "Facture %{token}",
                "invoices_number": {
                    "zero": "Aucune facture",
                    "one": "{{count}} facture",
                    "other": "{{count}} factures"
                },
                "total_for_month": "**{{yearMonth}}**:&NewLine;&NewLine;**{{invoiceNb}}** pour un total de **{{netSalary}}**",
                "worker": "Employé",
                "invoice_details": "Détails de la facture",
                "worked_hours_in_this_invoice": "Heures effectives",
                "issued_at": "Émise le",
                "paid_at": "Payée le",
                "amount": "Montant",
                "see_invoice": "Voir la facture",
                "filename_invoice": "facture-{{month}}-{{year}}-{{workerName}}",
                "related_activity": "Activité associée",
                "period": "Période",
                "refunded_status": "Remboursée",
                "final_settlement": "Facture",
                "down_payment": "Acompte",
                "correction": "Correction",
                "cannot_load_invoices": "Désolé, une erreur s'est produite lors du chargement.",
                "wait_invoice_asset": "Nous sommes en train de télécharger votre facture. Veuillez patienter quelques instants…"
            },
            "notifications": {
                "title": "Notifications",
                "have_actions_to_do": "Vous avez plusieurs actions à entreprendre:",
                "to_process_now": "À traiter de suite",
                "enter_timesheet": "Saisie des heures",
                "validate_timesheet": "Valider les heures",
                "timesheetNotificationTitle": "Timbrage",
                "timesheetNotificationBody": "N'oubliez pas de noter vos heures de travail."
            },
            "timesheet_review": {
                "worked_hours_recap": "Récapitulatif des heures effectives",
                "worked_hours_period": "Heures effectuées pour la période du:",
                "send_for_review": "Envoyer",
                "hours_breakdown": "Détails",
                "save": "Sauvegarder et quitter",
                "hours_at": "Heures à",
                "contest": "Contester",
                "contested": "Refusé",
                "reject": "Rejeter la fiche horaire",
                "approve": "Accepter les heures",
                "rejected_hours": "Heures refusées",
                "submitted_info": "La fiche horaire a été envoyée.",
                "auto_submit_info": "La fiche horaire sera automatiquement acceptée %{time}.",
                "mission_start": "Début du contrat de travail",
                "mission_ending": "Fin du contrat de travail",
                "client_status": {
                    "open": "En attente de la fiche horaire de la part de l'employé",
                    "submitted": "Validez la fiche en soumettant le décompte mensuel.",
                    "accepted": "Cette fiche horaire a été acceptée le {{date}}.",
                    "rejected": "Refusée le {{date}}."
                },
                "worker_status": {
                    "open": "La fiche horaire n'a pas encore été envoyée pour validation.",
                    "submitted": "Votre fiche horaire est en attente de validation.",
                    "accepted": "Acceptée le {{date}}",
                    "rejected": "Refusée le {{date}}"
                },
                "reject_alert": {
                    "title": "Contester les heures",
                    "description": "Êtes-vous sûr de vouloir contester les heures de cette fiche horaire?",
                    "confirm": "Oui, contester",
                    "cancel": "Non, annuler"
                },
                "declare_inactive": "Déclarer inactif",
                "locked": "Cette fiche horaire ne peut plus être modifiée car elle a déjà été acceptée.",
                "too_early": "Vous ne pouvez pas encore envoyer cette fiche horaire pour validation.",
                "validate_title": "Fiche horaire",
                "reject_description": "Si le décompte vous semble contenir une erreur, vous pouvez le contester afin qu'il soit revu et corrigé.",
                "accepted_locked": "Cette fiche horaire ne peut plus être modifiée, car elle a déjà été acceptée.",
                "submitted_locked": "Cette fiche horaire est en attente de validation par l’employeur. Si vous voulez y apporter des modifications, veuillez lui demander de rejeter cette fiche."
            },
            "life": {
                "setupText": "{{firstName}}, Lift vous permet de planifier votre retraite afin de mieux anticiper les aléas de la vie."
            },
            "create_mission_intro": {
                "title": "Déroulement du contrat de travail",
                "description": "Comment créer un contrat de travail (description) <br>"
            },
            "create_mission_job_title": {
                "title": "Indiquez le type de poste",
                "job": "Type d'activité",
                "job_title": "Intitulé du poste (facultatif)",
                "description": "Description des tâches (facultatif)",
                "default_cct": "CCT – Location de services",
                "default_cct_description": "la convention collective de travail (CCT) pour la location de services (ILSE) s’applique par défaut du moment que vous utilisez Lift.",
                "cct_details": "Détails de la CCT",
                "description_top": "Les informations suivantes sont nécessaires pour définir le salaire minimum du secteur d'activité concerné.",
                "missionAnnexQuestion": "Voulez-vous ajouter des documents annexes?",
                "missionAnnexInfo": "Vous pouvez, si vous le souhaitez, joindre un cahier des charges, un règlement ou des clauses particulières déjà signées. Ces documents sont transmis à titre informatif. En cas de différence d’interprétation, les dispositions du contrat conclu avec {{legalEmployerName}} s'appliquent.",
                "missionAnnexUpload": "Importer un document",
                "missionAnnexAddInLine": "Écrire une note",
                "office_job": "Est-ce un poste de bureau?",
                "yes": "Oui",
                "no": "Non",
                "description_allowances": "Le type de poste nous permet de déterminer la partie d'entreprise pour l'assurance-accidents."
            },
            "create_mission_salary": {
                "salaryType": {
                    "gross": "Brut",
                    "net": "Net",
                    "invoice": "Facturé",
                    "base": "de base",
                    "base_13x": "Base (13x)"
                },
                "help": "Plus d'informations",
                "invoice_month_label": "Facturé à l'employeur/mois",
                "invoice_hour_label": "Facturé à l'employeur/heure",
                "gross_month_label": "Salaire brut/mois",
                "gross_hour_label": "Salaire brut/heure",
                "net_month_label": "Salaire net/mois",
                "net_hour_label": "Salaire net/heure",
                "show_details": "Afficher le décompte détaillé",
                "detailed_working_time": {
                    "salary": "Salaire",
                    "pricing": "Tarifications",
                    "description_1": "Dans le contexte de la location de services, il y a plusieurs types de rémunération selon le jour et l'heure où le travail a été réalisé:",
                    "description_2": "Les chiffres indiqués sur l’écran sont basés sur un tarif à 100%.\n\nLe salaire effectif sera calculé en se basant sur les heures effectives travaillées (timbrage).",
                    "officeWorkHours": "Horaires de bureau",
                    "officeWorkHours_1": "du lundi au vendredi",
                    "officeWorkHours_2": "ne commence pas avant 6h",
                    "officeWorkHours_3": "ne se termine pas après 22h",
                    "nightHours": "Horaires de nuit/samedi",
                    "nightHours_1": "Samedi, ou",
                    "nightHours_2": "horaire entre 22h et 6h",
                    "nightHours_3": "Temps quotidien au-delà de 9.5 heures",
                    "sundayHours": "Horaire dominical",
                    "sundayHours_1": "Dimanche"
                },
                "calculationsExplained": "Ces calculs comprennent:",
                "weeksOfHolidays": "{{weeksOfHolidays}} semaines de vacances",
                "days": "{{days}} jours",
                "lpp": "un plan de prévoyance 2ᵉ pilier (LPP)",
                "withoutTaxes": "Charges patronales incluse (hors TVA)",
                "informations": "Informations",
                "vacation_days_format": "{{days}} jours",
                "vacation_days_full_week_format": "{{days}} jours ({{nbWeeks}} semaines)",
                "base_hour_label": "Salaire de base/heure",
                "base_month_label": "Salaire de base/mois",
                "vacationExplained": "Nombre de jours de vacances par an (sur une base à 100%)",
                "13th_salary_included": "Le 13ᵉ salaire est inclus dans le salaire mensuel",
                "corresponding_paid_salary": "Le salaire payé sera de {{paidSalary}}",
                "corresponding_base_salary": "Salaire de base correspondant: {{baseSalary}}",
                "net_salary_info": "Le salaire net reste indicatif et il est calculé hors impôts à la source.",
                "invoice_day_label": "Facturé à l'employeur/jour",
                "gross_day_label": "Salaire brut/jour",
                "net_day_label": "Salaire net/jour",
                "base_day_label": "Salaire de base/jour",
                "invoice_package_label": "Facturé à l'employeur",
                "gross_package_label": "Salaire brut",
                "net_package_label": "Salaire net",
                "base_package_label": "Salaire de base",
                "invoice_label": "Facturé à l'employeur",
                "gross_label": "Salaire brut",
                "net_label": "Salaire net",
                "vacation_percentage": "%{count} jours de vacances (taux d'activité de %{percent}%)",
                "ijmExplained": "Couverture de l'employé en cas de maladie",
                "setIjmAction": "Sélectionner la couverture IJM",
                "setVacationDays": "Sélectionner le nombre de jours",
                "salary_breakdown": "Résumé",
                "compute_salary_missing_data": "Il nous manque quelques informations pour finaliser le calcul du salaire. Pour y remédier, retournez aux étapes précédentes, re-sélectionnez la CCT, puis relancez le calcul.",
                "lppExplained": "Prévoyance professionnelle (LPP)",
                "workerGroupExplained": "Groupe de travailleurs",
                "setWorkerGroup": "Sélectionner un groupe",
                "ijmInfoTitle": "#### Indemnités journalières en cas de maladie (IJM)",
                "lppInfoTitle": "#### Prévoyance professionnelle (LPP)",
                "socialChargesTitle": "Charges sociales",
                "forceAvsAction": "Cotiser à l'AVS",
                "forceAvsLegend": "L'employé et l'employeur peuvent décider ensemble de cotiser ou non à l'AVS.",
                "onDemandAvsLegend": "Contrat sur appel : aucun volume de travail n'étant garanti, l'assujettissement à l'AVS est choisi ici.",
                "onDemandLppAction": "Affilier à la LPP",
                "onDemandLppLegend": "Requiert l'AVS. Sans affiliation, la LPP s'applique quand même si le plan n'a pas de seuil d'entrée.",
                "lppLegend": "La LPP correspond au 2ᵉ pilier, le système d'épargne destiné à la retraite.",
                "ijmLegend": "L'IJM est une indemnité versée en cas de maladie afin de maintenir le salaire de l'employé.",
                "vacationAndCagnotageTitle": "Vacances",
                "vacationEditorTitle": "Choisissez le nombre de jours de vacances pour un taux d'activité de 100%.",
                "cagnotteVacationsTitle": "Cagnotte vacances",
                "cagnotteVacationsAction": "Cagnotter les vacances",
                "cagnotteVacationsLegend": "L'indemnité s'accumule au fil des jours travaillés. Lift la conserve en réserve et la verse au travailleur lorsqu'il prend effectivement ses vacances.",
                "cagnotteVacationsObligatoireLegend": "Le cagnotage vacances est obligatoire si une CCT l'impose, si le taux d'activité est de 100 %, ou si un collaborateur payé à l'heure travaille régulièrement selon les horaires prévus par son contrat.",
                "cagnotteVacationsNonTrackedLegend": "Pour ce type de mission, l'indemnité de vacances est systématiquement versée avec le salaire. Les vacances ne faisant pas l'objet d'un suivi, le cagnotage vacances ne peut pas être activé.",
                "cagnotageObligatoire": "Cagnotage obligatoire",
                "cagnotageApplique": "Cagnotage appliqué",
                "cagnotageNonApplique": "Cagnotage non appliqué",
                "setLppAction": "Sélectionner le plan",
                "13th_salary_paid_separately": "13ᵉ salaire versé séparément",
                "thirteenth_salary_title": "13ᵉ salaire",
                "thirteenth_salary_editor_title": "Choisissez si le contrat comprend un 13ᵉ salaire et comment il est versé.",
                "thirteenth_salary_switch": "13ᵉ salaire",
                "thirteenth_salary_mandatory": "Obligatoire selon la CCT",
                "thirteenth_salary_none": "Sans 13ᵉ salaire",
                "thirteenth_salary_included": "Inclus",
                "thirteenth_salary_12x": "Versé avec chaque salaire (12x)",
                "thirteenth_salary_12x_description": "Le 13ᵉ salaire est inclus dans le salaire mensuel.",
                "thirteenth_salary_13x": "Versé séparément (13x)",
                "thirteenth_salary_13x_description": "Versé en décembre, en fin de contrat ou sur demande."
            },
            "create_mission_salary_monthly": {
                "title": "Salaire mensuel",
                "requested_salary_label": "Salaire mensuel",
                "min_salary_info": "Le salaire mensuel brut minimum à {{percentage}}% est de {{percentageAmount}}.",
                "counting_details": "[Décompte mensuel détaillé](SalaryCountingDetails)",
                "working_percentage_info": "Durée hebdomadaire: {{duration}} ({{percentage}}%)",
                "min_salary_info_plus": "Le salaire mensuel {{salaryType}} minimum à {{percentage}}% est de {{percentageAmount}}."
            },
            "create_mission_salary_hourly": {
                "title": "Salaire horaire",
                "requested_salary_label": "Salaire horaire",
                "min_salary_info": "Le salaire horaire brut minimum est de {{amount}}.",
                "counting_details": "[Décompte horaire détaillé](SalaryCountingDetails)",
                "min_salary_info_plus": "Le salaire horaire {{salaryType}} minimum est de {{amount}}."
            },
            "salary_counting_details": {
                "title": "Voici le décompte détaillé du salaire et des charges",
                "close": "Fermer",
                "description": "Le statut d'employé offre de nombreuses prestations, déduites du salaire, qui assure sa protection.",
                "client_deductions": "Charges employeur",
                "worker_deductions": "Charges sociales",
                "show_details": "Détails",
                "hide_details": "Cacher les détails",
                "invoiced_to_client": "Facturé à l'employeur",
                "gross_salary": "Salaire brut",
                "base_salary": "Salaire de base",
                "net_salary": "Salaire net",
                "holiday_13th_compensations": "Indemnités vacances, jours fériés et 13ᵉ mois",
                "paid_to_your_account": "Versé sur le compte",
                "client_salary_title": "Part employeur",
                "worker_salary_title": "Part employé",
                "13th_compensations": "13ᵉ salaire",
                "total_with_client_deductions": "Salaire avec charges",
                "paid_salary": "Salaire versé à l'employé",
                "vacancy_indemnity": "Provisions vacances",
                "invoiced_salary": "Salaire facturé",
                "taxes": "TVA ({{percent}}%)",
                "basquiat_margin": "Frais de service ({{percent}}%)",
                "lse_fees": "Frais de service",
                "screen_title": "Décompte détaillé",
                "avs": "AVS/AI/APG ({{percent}}%)",
                "ac": "AC ({{percent}}%)",
                "pc_fam": "LPC Famille ({{percent}}%)",
                "alloc_fam": "Allocations familiales ({{percent}}%)",
                "laap": "LAAP ({{percent}}%)",
                "laanp": "LAANP ({{percent}}%)",
                "ijm": "IJM ({{percent}}%)",
                "fcfp": "FCFP ({{percent}}%)",
                "management_fees": "Frais de gestion ({{percent}}%)",
                "training_costs": "Formation ({{percent}}%)",
                "lpp": "LPP ({{percent}}%)",
                "thirteen_month_compensation": "Part du 13ᵉ salaire",
                "public_holidays_compensation": "Indemnité relative aux jours fériés",
                "vacations_compensation": "Indemnités de vacances",
                "SECOND_OEUVRE_ROMAND_LPP_PRE": "Rente transitoire CRP ({{percent}}%)",
                "SECOND_OEUVRE_ROMAND_CSP": "Solidarité professionnelle ({{percent}}%)",
                "SECOND_OEUVRE_ROMAND_CRP": "Cotisation patronale pour la relève ({{percent}}%)",
                "SECOND_OEUVRE_ROMAND_APG_PLUS": "Cotisations complémentaires aux APG ({{percent}}%)",
                "PEINTURE_PLATRERIE_LPP_PRE": "Rente transitoire MPR ({{percent}}%)",
                "ALLOC_FAM_VD": "Cotisation Famille VD ({{percent}}%)",
                "PC_FAM_VD": "Cotisation LPCFam VD ({{percent}}%)",
                "ALLOC_FAM_GE": "Cotisation Famille GE ({{percent}}%)",
                "MAT_GE": "Cotisation Maternité GE ({{percent}}%)",
                "ALLOC_FAM_VS": "Cotisation Famille VS ({{percent}}%)",
                "PC_FAM_VS": "Cotisation LPCFam VS ({{percent}}%)",
                "ALLOC_FAM_AG": "Cotisation Famille AG({{percent}}%)",
                "ALLOC_FAM_ZH": "Cotisation Famille ZH ({{percent}}%)",
                "ALLOC_FAM_BE": "Cotisation Famille BE ({{percent}}%)",
                "ALLOC_FAM_LU": "Cotisation Famille LU ({{percent}}%)",
                "ALLOC_FAM_UR": "Cotisation Famille UR({{percent}}%)",
                "ALLOC_FAM_SZ": "Cotisation Famille SZ ({{percent}}%)",
                "ALLOC_FAM_OW": "Cotisation Famille OW ({{percent}}%)",
                "ALLOC_FAM_NW": "Cotisation Famille NW ({{percent}}%)",
                "ALLOC_FAM_GL": "Cotisation Famille GL ({{percent}}%)",
                "ALLOC_FAM_ZG": "Cotisation Famille ZG ({{percent}}%)",
                "ALLOC_FAM_FR": "Cotisation Famille FR ({{percent}}%)",
                "ALLOC_FAM_SO": "Cotisation Famille SO ({{percent}}%)",
                "ALLOC_FAM_BS": "Cotisation Famille BS ({{percent}}%)",
                "ALLOC_FAM_BL": "Cotisation Famille BL ({{percent}}%)",
                "ALLOC_FAM_SH": "Cotisation Famille SH ({{percent}}%)",
                "ALLOC_FAM_AR": "Cotisation Famille AR ({{percent}}%)",
                "ALLOC_FAM_AI": "Cotisation Famille AI ({{percent}}%)",
                "ALLOC_FAM_SG": "Cotisation Famille SG ({{percent}}%)",
                "ALLOC_FAM_GR": "Cotisation Famille GR ({{percent}}%)",
                "ALLOC_FAM_TG": "Cotisation Famille TG ({{percent}}%)",
                "ALLOC_FAM_TI": "Cotisation Famille TI ({{percent}}%)",
                "ALLOC_FAM_NE": "Cotisation Famille NE ({{percent}}%)",
                "ALLOC_FAM_JU": "Cotisation Famille JU ({{percent}}%)",
                "info_fee": "Hors frais Lift de 19.– / mois / employé",
                "worker_monthly_deductions_info": "Les charges suivantes seront déduites du salaire chaque mois:",
                "client_monthly_deductions_info": "Les charges suivantes seront ajoutées au montant facturé chaque mois:",
                "lift_monthly_fee": "Frais Lift, une fois par mois et par employé",
                "employer_period_total": {
                    "hourly": "Total payé par l'employeur par heure",
                    "daily": "Total payé par l'employeur par jour",
                    "monthly": "Total payé par l'employeur par mois",
                    "package": "Total payé par l'employeur pour le contrat"
                },
                "employer_vacation_note": "Ce montant doit également être versé pendant les vacances de l’employé, au moment du versement des indemnités de vacances.",
                "worker_vacation_note": "Ce salaire est également versé pendant les vacances, à partir des provisions constituées à cet effet.",
                "thirteenth_provision": "Provision 13ᵉ salaire",
                "worker_13th_note": "Le 13ᵉ salaire est versé en décembre, en fin de contrat ou sur demande.",
                "employer_13th_note": "Le 13ᵉ salaire est payé lors de son versement, en décembre, en fin de contrat ou sur demande."
            },
            "create_mission_fees": {
                "title": "Frais forfaitaires",
                "description": "Dans le cadre de ce contrat de travail, veuillez indiquer si vous prenez en charge des frais professionnels. Ces frais concernent des dépenses courantes engagées par l'employé qui lui sont ensuite remboursées.",
                "fees_type": "Type de frais",
                "next_title": "Suivant",
                "total_with_charge": "{{amount}} charges sociales comprises",
                "add_other_fees": "Ajouter d'autres frais",
                "delete_other_fees": "Supprimer le frais",
                "remove_title": "Supprimer le frais",
                "remove_info": "Êtes-vous sûr de vouloir supprimer ce frais?",
                "do_remove": "Oui, supprimer",
                "cct_nettyoyage_romand_food": "La CCT de nettoyage fixe l’indemnité repas à CHF 18.50.",
                "cct_fixed_fee": "Cette indemnité est fixée par la CCT."
            },
            "create_mission_activity_type": {
                "title": "Type d’activité",
                "label": "Activité",
                "search": "Rechercher...",
                "description_top": "Choisissez la catégorie qui correspond le mieux à l'activité.",
                "type_to_search": "Tapez les trois premières lettres pour commencer votre recherche.",
                "no_result": "Malheureusement, aucune activité ne correspond à votre recherche."
            },
            "create_mission_client": {
                "title": "L'employeur",
                "description_top": "Choisissez un employeur existant ou recherchez et ajoutez un nouvel employeur.",
                "placeholder": "Rechercher (par n° téléphone ou e-mail)",
                "add_label": "Ajouter un nouvel employeur",
                "client_card_description": {
                    "zero": "",
                    "one": "1 contrat de travail",
                    "other": ""
                },
                "enter_client_email": "Saisissez l'e-mail de votre contact employeur.",
                "no_client_found": "Aucun contact existant n’a été trouvé dans nos registres.\n\nMerci de demander à votre contact de créer un compte Lift.",
                "invite_button": "Envoyer une invitation",
                "i_have_understood": "J'ai compris.",
                "my_clients": "ou sélectionnez un employeur existant"
            },
            "create_mission_worker": {
                "title": "Sélectionnez un employé pour ce contrat de travail",
                "add_label": "Inviter un nouvel employé",
                "worker_card_description": {
                    "zero": "",
                    "one": "1 contrat de travail au total",
                    "other": "{{count}} contrats de travail au total"
                },
                "is_invitation": "Invitation en attente",
                "no_permit": "Absence de permis de travail",
                "permit_in_process": "Demande de permis en cours",
                "test_worker": "Employé Test",
                "test_worker_description": "Utilisez cet employé pour simuler le processus et le calcul du salaire",
                "invite_worker": "Inviter un employé",
                "incomplete_profile": "Profil employé en cours de création",
                "cannot_change_employee": {
                    "title": "Changer d'employé",
                    "description": "Pour changer d'employé, annulez la mission depuis la page du contrat en sélectionnant \"Annuler le contrat de travail\""
                }
            },
            "create_mission_working_address": {
                "title": "Indiquez le lieu où se déroulera l'activité",
                "description_top": "Veuillez spécifier le lieu où se déroulera l'activité. Si l'employé est amené à travailler à plusieurs endroits ou en télétravail, l’adresse du siège de l'entreprise fait foi.",
                "client_address_title": "Adresse identique à l’entreprise",
                "other_address_title": "Choisir une autre adresse",
                "add_address": "Autre adresse",
                "other_address": "Autre adresse",
                "tip": "Cette information sert uniquement à déterminer les éventuelles conventions collectives de travail (CCT) qui peuvent s'appliquer en fonction de la ville ou du canton où se déroule l'activité.",
                "private_client_address_title": "Adresse",
                "private_client_description_top": "Veuillez préciser l'adresse du domicile où se déroulera l'activité. Si l'employé doit intervenir dans plusieurs espaces du ménage, merci d'indiquer l'adresse principale.",
                "incomplete_address": "L'adresse est incomplète. Merci de la compléter."
            },
            "create_mission_cct": {
                "title": "Êtes-vous affilié à une CCT?",
                "description_top": "Si vous êtes affilié à une Convention collective de travail (CCT), merci de le préciser ci-dessous.",
                "cannot_load": "Oups! Une erreur s'est produite lors du chargement de cette page. Pouvez-vous ré-essayer dans un instant?",
                "unsupported_cct": "Désolé, cette CCT n'est pas encore supportée par l'app, mais nous y travaillons!\n\nVeuillez contacter l'[assistance](intercom://) pour plus d'informations.",
                "default_cct_description": "La CCT de Location de services sera appliquée par défaut.",
                "get_worker_infos": "Vous trouverez des informations concernant la formation et l'expérience de {{name}} ci-dessous.\n\n[Plus d'information]()",
                "modal_title_prefix": "Informations sur",
                "modal_intro": "Vous trouverez les points principaux concernant {{name}}:",
                "age": "Âge",
                "training": "Formation",
                "years_experiences": "Années d'expérience",
                "age_value": "{{age}} ans",
                "years_experiences_value": "{{yearsExperiences}} ans",
                "no_years_experiences": "Aucune expérience",
                "document": "Document {{index}}",
                "cct_details_link": "Lire la CCT sélectionnée",
                "no_cct": "Aucune CCT",
                "other_cct": "Affilié à une autre CCT",
                "dont_know": "Je ne sais pas…",
                "lse_cct": "Location de services",
                "need_help": "Si vous ne savez pas à quelle CCT vous êtes affilié, veuillez prendre contact avec notre service d'assistance et nous vous renseignerons.\n\nVous pourrez ensuite reprendre le processus de création du contrat de travail.",
                "show_help": "Contactez l'assistance",
                "other_cct_tip": "Si votre CCT ne fait pas partie de la liste ci-dessous, veuillez sélectionner la CCT \"Location de services\".",
                "no_cct_select": "Si vous êtes dans le doute ou si vous êtes affilié à une autre CCT, [veuillez contacter l'assistance.](intercom://)",
                "private_client_title": "Complément d'informations",
                "private_description_top": "Les informations suivantes sont nécessaires pour définir le salaire minimum du secteur d'activité concerné.",
                "no-cct-info": "En l’absence de CCT, la loi sur le travail et le code des obligations font foi.",
                "default_lse": "La CCT Location de services s'applique par défaut.",
                "select_cct": "Sélectionnez la CCT à appliquer",
                "hours_adjusted_title": "Durée de travail mise à jour",
                "hours_adjusted_message": "La durée de travail hebdomadaire a été mise à jour, passant de {{oldHours}} heures à {{newHours}} heures par semaine, afin de s'aligner sur la CCT que vous avez choisie.",
                "hours_adjusted_message_default_cct": "La durée maximale de travail hebdomadaire a été mise à jour, passant de {{oldHours}} heures à {{newHours}} heures par semaine, afin de s'aligner sur la CCT Location de services."
            },
            "create_mission_cct_details": {
                "title": "Détails sur la CCT",
                "description_top_extra": "Vous avez sélectionné la CCT \"{{cctName}}\".\n\nPour être conforme aux règles de cette CCT, il nous faut les informations suivantes concernant ce contrat de travail:",
                "description_top_no_extra": "Vous avez sélectionné la CCT \"{{cctName}}\". Cette CCT ne contient aucune spécificité.",
                "error_loading_fields": "Oups! Une erreur s'est produite. Pouvez-vous ré-essayer dans un petit moment?",
                "show_help": "Informations générales sur le formulaire ci-dessus",
                "region_description": "Indiquez la région où se déroulera l'activité",
                "contact_assistance": "Si vous avez un doute sur le choix de la CCT (Convention collective de travail), n’hésitez pas à [contacter l'assistance](intercom://).",
                "personnel_categery": "Sélectionnez la catégorie suivant les qualifications de l'employé",
                "region_help": "Si l'employé est amené à travailler à plusieurs endroits ou en télétravail, l'adresse du siège de l'entreprise fait foi.",
                "introduction_period": "Le contrat est-il conclu pendant ou après la période d'introduction?",
                "business_type": "Quelle description correspond le mieux à votre établissement?",
                "experience_level": "Indiquez l’expérience de l’employé dans le secteur lié au contrat.",
                "default_title": "Choisissez une option ci-dessous"
            },
            "create_mission_duration": {
                "title": "Période de travail",
                "cdi_label": "Durée indéterminée (CDI)",
                "cdd_label": "Durée déterminée (CDD)",
                "add_start_date": "Sélectionner une date",
                "start_date_label": "Début du contrat de travail",
                "end_date_label": "Fin du contrat de travail",
                "invalid_start_date": "Veuillez choisir une date valide de début de contrat.",
                "indeterminate": "Indéterminée",
                "review_description_daily": "L'employé travaillera {{workingTime}} durant la période définie ci-dessus.",
                "review_description_hourly": "L'employé travaillera {{workingTime}} durant la période définie ci-dessus."
            },
            "create_mission_earning_type": {
                "title": "Type de contrat",
                "description_top": "Le salaire est calculé sur une base forfaitaire.",
                "monthly": {
                    "label": "Mensuel",
                    "description": "Le salaire est calculé sur une base mensuelle."
                },
                "hourly": {
                    "label": "Horaire",
                    "description": "Le salaire est calculé sur une base horaire."
                },
                "working_percent_format": "{{hours}} heures/semaine = 100%",
                "select_working_percentage": "Sélectionnez un taux d'activité",
                "hours_per_week": "Afin de déterminer la rémunération de façon précise, veuillez indiquer le nombre d'heures de travail par semaine que l'employé devrait effectuer s'il s'agissait d'un temps plein (100%).",
                "time_sheets": "La fiche horaire remplie par l'employé fera foi dès qu'elle aura été validée par l'employeur.",
                "hours_per_week_placeholder": "Sélectionnez",
                "oneShot": {
                    "label": "Ponctuel",
                    "description": "L’employé travaille à une ou des dates spécifiques, avec un salaire calculé sur une base horaire."
                },
                "daily": {
                    "label": "Journalier",
                    "description": "Le salaire est calculé sur une base journalière."
                },
                "package": {
                    "label": "Forfait",
                    "description": "Le salaire consiste en un montant fixe convenu au préalable."
                },
                "default_value": "Par défaut"
            },
            "create_mission_working_time": {
                "title": "Horaires de travail",
                "classic": {
                    "label": "Horaire hebdomadaire standard",
                    "description": "- du lundi au vendredi\n- ne commence pas avant 6h\n- ne se termine pas après 22h"
                },
                "schedule": {
                    "label": "Horaire hebdomadaire spécifique",
                    "description": "- jours/heures fixes hebdomadaires (p. ex. 7h - 14h)\n- dimanche/jours fériés\n- travail de nuit"
                },
                "specific": {
                    "label": "Date/heure spécifique",
                    "description": "- journée/heure spécifique"
                },
                "use_company_policy": "Utiliser le règlement d'entreprise pour fixer les horaires."
            },
            "create_mission_working_time_more": {
                "title": "Temps de travail",
                "minimum_duration_error": "La durée hebdomadaire doit être supérieure à une heure."
            },
            "create_mission_summary": {
                "title": "Récapitulatif",
                "description": "Vérifiez les informations ci-dessous avant de passer à la signature du contrat.",
                "next_title": "Créer le contrat",
                "save_contract": "Enregistrer le contrat"
            },
            "create_mission_finish": {
                "title": "La proposition a été envoyée!",
                "description": "Ajouter descriptif",
                "next_title": "Accéder à mon tableau de bord"
            },
            "accept_worker_contract": {
                "title": "Signez le contrat cadre",
                "next_title": "Signer",
                "wait_asset_contract": "Votre contrat est en cours de préparation. Merci de patienter quelques instants…"
            },
            "accept_client_contract": {
                "title": "Signez les conditions générales de location de services",
                "next_title": "Signer",
                "wait_asset_contract": "Votre contrat est en cours de préparation. Merci de patienter quelques instants…"
            },
            "mission_accept_mission_contract": {
                "title_worker": "Signez le contrat de travail",
                "title_client": "Signez le contrat de location de services",
                "next_title": "Signer",
                "wait_asset_contract": "Votre contrat est en cours de préparation. Merci de patienter quelques instants…"
            },
            "done_message": {
                "next_title": "Accéder à mon tableau de bord",
                "worker_accepted_waiting": {
                    "title": "La proposition a été envoyée!",
                    "description": "La proposition de contrat a été soumise à Lift pour validation."
                },
                "worker_accepted_full": {
                    "title": "Le contrat est validé!",
                    "description": "On se réjouit de votre collaboration avec {{clientName}}. Les instructions de {{clientName}} vous seront envoyées prochainement."
                },
                "client_accepted_waiting": {
                    "title": "Proposition envoyée!",
                    "description": "La proposition de contrat a été soumise à Lift pour validation."
                },
                "client_accepted_full": {
                    "title": "Contrat validé!",
                    "description": "On se réjouit de votre collaboration avec {{workerName}}. N’oubliez pas de fournir vos instructions avant le début du contrat de travail."
                }
            },
            "contract_details": {
                "cannot_load": "Erreur de chargement!",
                "awaiting_talent_signature": "En attente de la signature de l'employé",
                "awaiting_client_signature": "En attente de la signature d'un responsable de contrat",
                "awaiting_your_signature": "En attente de votre signature",
                "awaiting_lift_signature": "En attente de la signature de Lift",
                "job_title": "Activité",
                "start_date": "Début du contrat de travail",
                "check_other_mission": "Veillez à ne pas avoir un autre contrat de travail en cours.",
                "end_date": "Fin du contrat de travail",
                "no_end_date": "Indéterminée",
                "work_percent": "Taux d'activité",
                "signing_state": "Statut de la signature",
                "signing": "Signature",
                "address": "Lieu",
                "work_time": "Temps de travail",
                "talent": "Employé",
                "contract_pdf": "Contrat de travail (PDF)",
                "rejected_reason": "Raison: {{reason}}. (Fin du contrat: {{terminationDate}})",
                "contract_rejected": "Contrat annulé",
                "contract_terminated": "Contrat résilié",
                "cct": "CCT",
                "signing_failed": "La signature a malheureusement échoué.\n\nVeuillez contacter l'[assistance](intercom://) pour plus d'information.",
                "processing_contracts": "En préparation",
                "signature_success": "Contrats signés avec succès",
                "signature_failed": "La signature a échoué.",
                "signature_cancelled_by_self": "Vous avez annulé la signature.",
                "signature_canceled_by_client": "La signature a été annulée par l'employeur.",
                "signature_canceled_by_worker": "La signature a été annulée par l'employé.",
                "signature_canceled_by_lift": "La signature a été annulée par Lift.",
                "processing_your_signature": "Votre signature est en cours de traitement.",
                "job_description": "Description",
                "legal_employer": "Employeur légal",
                "client": "Employeur",
                "mission_employer": "Employeur",
                "awaiting_self_client_signature": "En attente de la signature de {{clientName}} ({{clientUserName}})",
                "awaiting_lift_signature_long": "En attente de la signature de Lift dans les prochaines 24 heures ouvrables.",
                "discover_contract_steps": "Découvrir les différentes étapes du contrat",
                "pending_termination": "Demande de résiliation en cours de traitement",
                "amendment_awaiting_your_signature": "Avenant en attente de votre signature",
                "amendment_awaiting_worker_signature": "Avenant en attente de la signature de l'employé",
                "awaiting": "En attente",
                "signed": "Signé",
                "canceled": "Annulé",
                "awaiting_self_client_company_signature": "En attente de la signature de {{clientName}}",
                "handwitten_in_progress": "En attente de signature manuscrite"
            },
            "resend_verification_email": {
                "title": "Vérification",
                "text": "Malheureusement, votre e-mail n’a pas encore été validé.\nSi vous ne l'avez pas encore reçu, cliquez sur le bouton ci-dessous pour recevoir un nouvel e-mail de validation.",
                "button_text": "Renvoyer l'e-mail",
                "error_text": "Une erreur s'est produite lors de l'envoi de l'e-mail de vérification. Pouvez-vous réessayer?",
                "sent_text": "Un e-mail de vérification a été envoyé à {{email}}. Merci de vérifier votre boîte de réception."
            },
            "create_mission_hotellerieRestaurationFees": {
                "title": "Frais liés à la CCT",
                "description": "Si vous ne prenez pas en charge le nettoyage et le repassage des équipements suivants, merci de l'indiquer. Des indemnités relatives aux frais encourus pour chaque élément sélectionné seront ajoutées au salaire de l'employé.",
                "yes_no_fees": "Oui, fournis par l'établissement",
                "no": "Non, pas besoin",
                "yes_with_fees": "Oui, fournis par l'employé",
                "selectFeesDescription": "L’entreprise prend en charge:"
            },
            "create_mission_deductions": {
                "title": "Déductions",
                "info": "S’il y en a, indiquez les avantages en nature (repas, logement, véhicule, etc.) dont bénéficie l'employé et que vous souhaitez déduire du montant de son salaire.",
                "description_field": "Description",
                "next_title": "Suivant",
                "add_deduction": "Ajouter une déduction",
                "remove_deduction": "Supprimer la déduction",
                "remove_title": "Supprimer la déduction",
                "remove_info": "Êtes-vous sûr de vouloir supprimer cette déduction?",
                "do_remove": "Oui, supprimer"
            },
            "create_mission_time_sheet": {
                "title": "Fiche horaire",
                "info": "Sélectionnez le système de relevé d’heures que vous souhaitez utiliser. Le relevé d’heures servira à calculer la rémunération de l'employé.",
                "payroll_source_manual_client_title": "Fiche horaire externe",
                "payroll_source_manual_client_description": "Vous complétez vous-même un décompte mensuel des heures de travail de votre employé, que vous soumettez ensuite sur Lift.",
                "payroll_source_manual_client_tag": "Vous pourrez accéder au contrat et compléter le décompte du mois.",
                "payroll_source_lift_title": "Fiche horaire Lift",
                "payroll_source_lift_description": "L'employé saisit ses heures dans l'application chaque semaine et vous les soumet pour validation. Vous transmettez ensuite le décompte mensuel sur Lift."
            },
            "help": {
                "ask_assistance": "Demande d'assistance",
                "see_all_articles": "Voir tous les articles"
            },
            "todos": {
                "title": "Mes tâches",
                "no_activity": "Les actions que vous devez accomplir apparaîtront ici.",
                "cannot_load_todos": "Désolé, une erreur s'est produite lors du chargement.",
                "filters": {
                    "breakdown": "Décomptes",
                    "invoice": "Factures",
                    "contract": "Contrats",
                    "other": "Autres",
                    "account": "Compte",
                    "timesheet": "Fiches horaires",
                    "all": "Toutes les tâches"
                }
            },
            "activity_log": {
                "title": "Mon journal",
                "no_activity": "Votre fil d'activité apparaîtra ici."
            },
            "create_mission_salary_daily": {
                "title": "Salaire journalier",
                "requested_salary_label": "Salaire journalier",
                "min_salary_info": "Le salaire journalier brut minimum est de {{amount}}.",
                "counting_details": "[Décompte journalier détaillé](SalaryCountingDetails)",
                "min_salary_info_plus": "Le salaire journalier {{salaryType}} minimum est de {{amount}}."
            },
            "my_invoices": {
                "title": "Mes factures",
                "no_invoices": "Toutes vos factures seront visibles ici."
            },
            "create_mission_ijm": {
                "title": "IJM"
            },
            "create_mission_ijm_info": {
                "title": "Veuillez choisir votre plan IJM",
                "info_1": "Avant de créer un contrat de travail, vous devez sélectionner un plan d’indemnités journalières en cas de maladie.",
                "info_2": "Cette assurance avec le Groupe Mutuel, applicable à l’ensemble des contrats de travail de votre entreprise, assure le versement de 80% du salaire brut aux employés concernés, ceci dès le 3ᵉ, 15ᵉ ou 31ᵉ jour de maladie.",
                "in_collaboration_with": "En collaboration avec"
            },
            "create_mission_salary_package": {
                "title": "Salaire",
                "requested_salary_title": "Définissez le montant total",
                "requested_hours_title": "Indiquez le nombre d'heures de travail",
                "requested_salary_label": "Salaire",
                "min_salary_info": "Le salaire brut minimum est de {{amount}} pour {{hours}} heures de travail.",
                "counting_details": "[Décompte journalier détaillé](SalaryCountingDetails)",
                "min_salary_info_plus": "Le salaire {{salaryType}} minimum est de {{amount}} pour {{hours}} heures de travail.",
                "start_date": "Début",
                "end_date": "Fin",
                "max_hours": "Le temps de travail ne peut pas dépasser {{hours}} heures au total."
            },
            "my_colleagues": {
                "title": "Collègues",
                "joined_at": "Depuis le {{joinedAt}}",
                "can_sign": "Est habilité à signer des contrats",
                "invite_colleague": "Inviter un collègue",
                "you": "{{name}} (vous)"
            },
            "timesheets": {
                "cannot_load_timesheets": "Désolé, une erreur s'est produite lors du chargement."
            },
            "create_mission_test_worker": {
                "title": "Configuration de l'employé test",
                "description": "Personnalisez les informations de l'employé test pour obtenir un calcul de salaire précis."
            },
            "create_mission_simulation_summary": {
                "title": "Simulation terminée",
                "congratulations": "Félicitations!",
                "simulation_complete": "Vous avez terminé votre simulation de contrat de travail avec succès.",
                "salary_summary": "Résumé du salaire simulé",
                "email_results": "Envoyer les résultats par e-mail",
                "email_description": "Recevez un résumé détaillé de cette simulation directement dans votre boîte e-mail.",
                "email_placeholder": "votre.email@exemple.com",
                "send_email": "Envoyer par e-mail",
                "send_email_success": "La simulation a été envoyée.",
                "finish_without_email": "Terminer sans envoyer",
                "include_pdf_details": "Détails du salaire en PDF",
                "include_contract_examples": "Exemples de contrats-types"
            },
            "colleague_details": {
                "colleague": "Collègue",
                "no_contracts": "Aucun contrat en cours",
                "contracts": "Contrats en cours"
            }
        },
        "client_profile_edit": {
            "title": "Modifier mon profil employeur",
            "edit_email": "Modifier l'adresse e-mail professionnelle"
        },
        "worker_profile_edit": {
            "title": "Modifier mon profil"
        },
        "client_edit": {
            "title": "Entreprise",
            "name_error": "Le nom de l'entreprise est obligatoire.",
            "address_error": "L'adresse est obligatoire.",
            "save_error": "Désolé, une erreur s'est produite lors de la sauvegarde de vos informations. Merci de réessayer."
        },
        "account_edit": {
            "title": "Modifier mon compte"
        },
        "bank_account_edit": {
            "title": "Données bancaires"
        },
        "work_permit_edit": {
            "title": "Permis de travail",
            "no_work_permit_error": "Vous devez sélectionner un permis de travail."
        },
        "configure_lpp": {
            "title": "Prévoyance",
            "submit_request": "Envoyer la demande",
            "intro": "Nous allons vous affilier au Fonds de prévoyance (FIP) du Centre Patronal.",
            "see_plan": "Voir les détails du plan",
            "please_confirm": "Merci de confirmer les points suivants:",
            "has_full_working_capacity": "Je jouis de ma pleine capacité de travail.",
            "has_no_3_months_incapacity_in_last_12_months": "Je n'ai subi aucune incapacité de travail, partielle ou totale, supérieure à trois semaines, au cours des 12 derniers mois.",
            "has_no_incapacity_now": "Je jouis de ma pleine capacité de travail et ne souffre pas d'une infirmité, d'une maladie ou des suites d'un accident.",
            "has_received_disability_pension_in_last_3_years": "Je n'ai bénéficié d'aucune rente invalidité de l'AI au cours des trois dernières années.",
            "has_accepted_all": "Je déclare avoir répondu en toute conscience et confirme que les indications ci-dessus sont exactes et complètes. J'accepte les conditions ci-dessus.",
            "pension_level": "Niveau de rente",
            "disability_level": "Niveau d'invalidité",
            "25percentPension": "1/4 de rente",
            "50percentPension": "2/4 de rente",
            "75percentPension": "3/4 de rente",
            "100percentPension": "4/4 de rente",
            "percentOfDisability": "{{percent}}% d'invalidité"
        },
        "confirmation": {
            "done_thanks": "Et voilà, merci beaucoup!"
        },
        "invitations": {
            "titles": {
                "client": "Mes invitations",
                "worker": "Invitations en attente"
            },
            "empty": {
                "client": "Vous n'avez aucune invitation.",
                "worker": "Vous n'avez aucune invitation en attente."
            },
            "send": "Envoyer une nouvelle invitation"
        },
        "termination": {
            "actions": {
                "terminated": "Résilier le contrat",
                "cancelled": "Résilier le contrat",
                "ended": "Mettre fin au contrat de travail",
                "request": "Demander la résiliation",
                "support": "Assistance"
            },
            "action_errors": {
                "terminated": "La résiliation du contrat de travail a échoué.",
                "cancelled": "L'annulation du contrat de travail a échoué.",
                "ended": "Il n'a pas été possible de mettre fin à ce contrat de travail."
            },
            "get_errors": "Impossible de récupérer les informations relatives au contrat de travail",
            "get_info_errors": "Impossible de récupérer les informations nécessaires à la résiliation du contrat de travail",
            "labels": {
                "terminated": {
                    "reason": "Raison de la résiliation",
                    "termination_date": "Date de résiliation",
                    "ended": "Ce contrat de travail étant terminé, vous pouvez y mettre fin sans conséquence."
                },
                "cancelled": {
                    "reason": "Raison de l'annulation",
                    "termination_date": "Date de l'annulation",
                    "ended": "Ce contrat de travail étant terminé, vous pouvez y mettre fin sans conséquence."
                },
                "description": "Description"
            },
            "callouts": {
                "worker": {
                    "cancelled": "Le contrat sera annulé et votre employeur en sera informé.",
                    "terminated": "#### Merci de vérifier les points suivants:\n\n- Fin du contrat: **%{termDate}**\n- Cette action ne peut pas être annulée.\n- Le solde des heures validées vous sera versé à la fin du mois.\n- Votre employeur sera informé.",
                    "ended": "Ce contrat de travail étant terminé, vous pouvez y mettre fin sans conséquence.",
                    "request": "Si vous voulez résilier le contrat, merci d'en indiquer la raison. Notre service d'assistance vous contactera rapidement pour vous guider et répondre à vos questions."
                },
                "client": {
                    "cancelled": "Le contrat sera annulé et l'employé informé.",
                    "terminated": "N'oubliez pas d'informer l'employé de votre volonté de résilier le contrat. \n- Fin du contrat: **%{termDate}**\n- La résiliation du contrat de travail est définitive.\n- Le solde, qui comprend le délai de résiliation, vous sera facturé.\n- L'employé sera informé.",
                    "ended": "Ce contrat de travail étant terminé, vous pouvez y mettre fin sans conséquence.",
                    "request": "Si vous voulez résilier le contrat, merci d'en indiquer la raison. Notre service d'assistance vous contactera rapidement pour vous guider et répondre à vos questions."
                },
                "too_early": "La date de résiliation n'est pas dans le délai légal de résiliation. Pour être conforme à la loi, il vous faut choisir une date ultérieure ou égale au %{minimalEndDate}.",
                "already_requested": {
                    "self": "Votre demande de résiliation a déjà été soumise. Notre service d'assistance vous contactera prochainement.\n\nNous vous remercions pour votre patience et restons à votre disposition si vous avez d'autres questions.",
                    "other": "Une demande de résiliation a déjà été soumise. Pour toute demande de clarification, veuillez contacter l'assistance."
                }
            },
            "success_info": {
                "delete": "Le contrat de travail a été supprimé.",
                "terminate": "Le contrat de travail a été annulé.",
                "request": "Votre demande a bien été envoyée. Elle est actuellement en cours de traitement et nous vous tiendrons informé dès que possible."
            },
            "reason": {
                "relational_problem": "Problème relationnel",
                "not_signed_in_time": "Le contrat n'a pas été signé à temps",
                "inadequate_working_conditions": "Conditions de travail inadéquates",
                "overqualified_labor": "Surqualification de la main d'œuvre",
                "under_qualified_labor": "Sous-qualification de la main d'œuvre",
                "solvency_problem": "Problème de solvabilité de la société",
                "weather_condition_suitability": "Conditions météorologiques inadaptées",
                "worker_profile_missmatch": "L'employé ne correspond pas au profil.",
                "signing_rejected": "La signature du contrat a été refusée.",
                "busy_on_proposed_dates": "Non disponible aux dates proposées",
                "company_culture": "Culture d'entreprise",
                "distance": "Distance",
                "insufficient_compensation": "Rémunération insuffisante",
                "lack_of_professional_advancement": "Manque de perspectives professionnelles",
                "other": "Autre",
                "salary_too_high": "Salaire trop élevé",
                "skills_tasks_mismatch": "Les tâches ne correspondent pas aux compétences de l'employé.",
                "unjustified_absences": "Absences injustifiées",
                "person_didnt_signed_in_time": "Le contrat n'a pas été signé à temps par {{personName}}",
                "you_didnt_signed_in_time": "Vous n'avez pas signé le contrat à temps",
                "lift_didnt_signed_in_time": "Lift n'a pas signé le contrat à temps",
                "lse_didnt_signed_in_time": "Lift n'a pas signé le contrat à temps",
                "client_didnt_signed_in_time": "L'employeur n'a pas signé le contrat à temps",
                "worker_didnt_signed_in_time": "L'employé n'a pas signé le contrat à temps",
                "other_description": "Message:",
                "termination_date_by": "Résiliation au {{terminationDate}} par {{terminatedBy}}",
                "cancelation_date_by": "Annulation au {{terminationDate}} par {{terminatedBy}}"
            },
            "other_reason": "Autre raison",
            "missing_other_reason": "Veuillez spécifier la raison.",
            "reason_label": "Raison",
            "header_label": {
                "cancelled_by_self": "Vous avez annulé le contrat de travail",
                "cancelled_by_person": "Le contrat de travail a été annulé par {{personName}}",
                "cancelled_by_lse": "Le contrat de travail a été annulé par Lift"
            },
            "select_termination_date": "À quelle date souhaitez-vous mettre fin au contrat?",
            "select_date": "Choisir une date",
            "missing_date": "Date souhaitée obligatoire",
            "termination_date_wish": "Date souhaitée de résiliation du contrat:",
            "termination_reason": "Raison de la demande de résiliation:"
        },
        "mission_created": {
            "title": "Félicitations!",
            "description": "La proposition a été envoyée à %{workerName}.",
            "description_2": "Une fois que l'employé aura accepté le contrat de travail, nous vous transmettrons le contrat de location de services à signer et à nous retourner via l’application.",
            "description_3": "Enfin, Lift validera les contrats des deux parties.",
            "worker_contract": "Contrat de travail",
            "client_contract": "Contrat de location",
            "worker_contract_description": "Entre Lift et %{workerName}",
            "client_contract_description": "Entre %{clientName} et Lift",
            "button": "Mes contrats de travail"
        },
        "worker_missions": {
            "no_mission": "Cet employé n'a aucun contrat de travail."
        },
        "error_screen": {
            "not_found_title": "La page n'a pas été trouvée.",
            "error_title": "Erreur imprévue",
            "not_found_description": "Le contenu n'existe plus. Cela peut être dû à différentes raisons:\n<br>\n- le contenu est obsolète;\n- le lien n’est plus à jour;\n- une météorite perturbe le champ magnétique terrestre!\n\nNotre équipe a été informée et met tout en œuvre pour trouver une solution au plus vite.\n\nSi le problème persiste, n’hésitez pas à nous contacter.",
            "error_description": "Une erreur momentanée s’est produite. Cela peut être dû à:\n<br>\n- une interruption de la connexion internet;\n- un problème technique;\n- une météorite qui perturbe le champ magnétique terrestre!\n\nNotre équipe a été informée et met tout en œuvre pour trouver une solution au plus vite.\n\nSi le problème persiste, n’hésitez pas à nous contacter."
        },
        "cct_details": {
            "title": "Détails de la CCT"
        },
        "pre_sign": {
            "error": "Une erreur s'est produite lors de la récupération des informations du contrat.",
            "valid_info": "Vous allez maintenant pouvoir signer votre contrat.",
            "invalid_info": "{{contractType}} a déjà été signé ou a expiré.",
            "other_sign_info": "{{contractType}} doit être signé par l'autre partie avant que vous ne puissiez le signer.",
            "label_ready": "Voilà! {{contractType}} est prêt pour être lu et signé.",
            "label_waiting": "{{contractType}} est en cours de préparation...",
            "timeout": "Le chargement du contrat a pris trop de temps. Merci de réessayer ou de contacter l'assistance.",
            "timeout_retry": "Réessayer",
            "timeout_contact": "Contacter l'assistance",
            "read_and_sign_contract": "Vérifier et signer",
            "postpone_signing": "Signer plus tard",
            "contract": "Le contrat",
            "amendment": "L'avenant",
            "other_sign_contract": "Choisir un signataire",
            "handwritten_title": "Vous recevrez très prochainement votre contrat par courrier.",
            "handwritten_info": "Merci de signer le contrat et de nous le retourner dès que possible. Il sera ensuite ajouté à la section correspondante dans Lift."
        },
        "profile_editor": {
            "title": "Profil",
            "please_complete": "veuillez compléter",
            "children_number": {
                "zero": "Non",
                "one": "{{count}} enfant",
                "other": "{{count}} enfants"
            },
            "close_warning_title": "Êtes-vous sûr de vouloir quitter cette page?",
            "close_warning_description": "Les informations non sauvegardées seront perdues.",
            "quit": "Quitter",
            "continue": "Continuer",
            "finalize_my_signup": "Terminer",
            "civil_state": {
                "title": "AVS/État civil",
                "partner_first_name": "Prénom du conjoint",
                "partner_last_name": "Nom du conjoint",
                "partner_avs": "AVS du conjoint",
                "partner_has_revenue": "Est-ce que votre conjoint a un revenu?",
                "partner_revenue": "Salaire mensuel brut de votre conjoint",
                "partner_revenue_description": "Sans informations relatives au salaire, le taux d'imposition correspondra à la tranche la plus élevée du barème.",
                "has_other_activity": "Exercez-vous une autre activité en dehors de Lift?",
                "errors": {
                    "update_avatar_error": "Une erreur est survenue lors de l'enregistrement des données.",
                    "not_unique_own_avs": "Votre numéro AVS ne peut pas être le même que celui de votre conjoint.",
                    "not_unique_partner_avs": "Le numéro AVS de votre conjoint ne peut pas être le même que le vôtre.",
                    "update_worker_profile_error": "Une erreur est survenue lors de l'enregistrement des données.",
                    "partner_revenue_cannot_be_0": "Le revenu de votre conjoint ne peut pas être \"0\""
                },
                "civil_state": "État civil",
                "work_rate_percentage": "Taux d'activité en pourcentage",
                "work_rate_percentage_description": "Ces informations sont nécessaires pour déterminer le barème de l’impôt à la source.",
                "default_work_rate_percentage": "100 % (par défaut)",
                "no_avs_number": "Je n'ai pas de numéro AVS"
            },
            "fiscal_attestation": {
                "title": "Attestation fiscale",
                "has_fiscal_attestation": "Êtes-vous en possession d’une attestation fiscale?",
                "import_fiscal_attestation": "Importer l'attestation fiscale",
                "has_fiscal_attestation_description": "L’attestation officielle du pays de résidence doit être signée par l’institution. Si le document n'est pas valable, vous serez soumis à l’impôt à la source.",
                "has_no_fiscal_attestation_description": "Vous serez soumis à l'impôt à la source.",
                "upload_fiscal_attestation_error": "Une erreur est survenue lors du téléchargement de l'attestation."
            },
            "children": {
                "title": "Enfant(s) à charge",
                "do_you_have_children": "Avez-vous des enfants à charge?",
                "children_first_name": "Prénom de l'enfant",
                "children_last_name": "Nom de l'enfant",
                "children_birth_date": "Date de naissance de l'enfant",
                "children_gender": "Sexe de l'enfant",
                "children_avs": "AVS de l'enfant",
                "add_children": "Ajouter un enfant",
                "remove_children": "Supprimer l'enfant",
                "errors": {
                    "not_unique_avs": "Ce numéro AVS a déjà été utilisé."
                }
            },
            "bank_account": {
                "title": "Compte salaire"
            },
            "diploma_and_training": {
                "title": "Diplômes et formations"
            },
            "new_profile": "Nouveau profil",
            "home_address": {
                "title": "Adresse du domicile"
            },
            "title_client": "Profil employeur entreprise",
            "title_private_client": "Profil employeur domestique",
            "title_worker": "Profil employé",
            "administrative_data": "Informations administratives",
            "experiences": {
                "title": "Qualifications",
                "has_education": "Avez-vous suivi une formation ou acquis de l’expérience dans un métier en particulier?",
                "fill_in_data": "Ajoutez votre CV pour un salaire adapté à vos qualifications.",
                "import_cv": "Importer CV (PDF, LinkedIn)",
                "import_pdf": "Importer PDF",
                "import_linkedin": "Coller URL LinkedIn",
                "paste_linkedin_url": "Insérez l'URL de votre profil LinkedIn",
                "invalid_linkedin_link": "Lien LinkedIn invalide",
                "clear": {
                    "linkedin_link": {
                        "title": "Supprimer le lien LinkedIn",
                        "description": "Êtes-vous sûr de vouloir supprimer cet URL?"
                    },
                    "other": {
                        "title": "Supprimer le CV",
                        "description": "Êtes-vous sûr de vouloir supprimer votre CV? Vous pouvez le réimporter à tout moment si vous changez d’avis."
                    }
                },
                "clear_data": "Supprimer le CV",
                "create_cv": "Créer un CV manuellement",
                "trainings": "Formations",
                "experiences": "Expériences professionnelles",
                "education_level": "Niveau de la formation",
                "training_name": "Nom de la formation",
                "profession_name": "Intitulé du poste",
                "years_of_experience": "Années d'expérience",
                "add_training": "Ajouter une formation",
                "add_experience": "Ajouter une expérience",
                "pdf_cv": "CV PDF",
                "clear_data_description": "Êtes-vous sûr de vouloir effacer ce document?",
                "my_cv": "Mon CV",
                "view_link": "Visualiser le lien",
                "view_document": "Visualiser le document"
            },
            "curriculum_vitae_pdf": "Curriculum vitae PDF",
            "without_qualifications": "Sans qualifications",
            "kyc": {
                "title": "Vérification d'identité"
            },
            "private_email": {
                "title": "Adresse e-mail privée"
            },
            "email": {
                "title": "Adresse e-mail",
                "title_business": "Adresse e-mail professionnelle",
                "verify": "Vérifiez votre adresse e-mail",
                "verified_badge": "Vérifié",
                "not_verified_description": "Nous vous avons envoyé un e-mail. Cliquez sur le lien qu'il contient pour confirmer votre adresse e-mail afin de ne manquer aucune information ni aucun document important.",
                "verified_description": "Votre adresse e-mail a été vérifiée. Vous pouvez la modifier ici si nécessaire.",
                "verified_description_postonboarding": "Votre adresse e-mail a été vérifiée. Vous pouvez la modifier à tout moment depuis votre profil.",
                "resend": "Renvoyer l'e-mail de vérification",
                "resend_sent": "Un e-mail de vérification a été envoyé à {{email}}. Cliquez sur le lien qu'il contient pour confirmer votre adresse e-mail.",
                "private_email_required_description": "Renseignez une adresse e-mail pour votre profil employé. Vous recevrez ensuite un e-mail contenant un lien pour confirmer votre nouvelle adresse."
            }
        },
        "payroll_breakdown_list": {
            "title": "Décomptes",
            "cannot_load": "Impossible de charger les décomptes",
            "submit_breakdown": "Vérifier et valider le décompte",
            "no_breakdowns": "Aucun décompte",
            "complete_timesheets": "Compléter les fiches horaire",
            "check_submit_breakdown": "Vérifier et valider le décompte",
            "fill_submit_breakdown": "Compléter le décompte",
            "fix_timesheets": "Corriger les fiches horaire"
        },
        "payroll_breakdown": {
            "title": "Décompte",
            "cannot_load": "Impossible de charger le décompte",
            "show_timesheets_action": "Fiches horaires",
            "timesheets": "Fiches horaires",
            "info_text": {
                "client": {
                    "submitted": "Le décompte a été soumis le %{date}.",
                    "external_ts": "Veuillez compléter le décompte.",
                    "lift_ts_completed": "Veuillez valider votre décompte.\n\nLes données ci-dessous ont été calculées à partir des fiches horaires fournies par l'employé.",
                    "lift_ts_open": "Veuillez valider le décompte dès que l'employé vous aura transmis ses fiches horaires pour cette période.",
                    "empty_period": "Ce décompte mensuel concerne uniquement les semaines se terminant avant le 20 du mois. Étant donné que l'activité a débuté après cette date, aucune semaine n’est incluse dans ce décompte.",
                    "auto_submitted": "Le décompte a été validé automatiquement le %{date} par Lift."
                },
                "worker": {
                    "submitted": "Décompte soumis le %{date} par %{clientName}.",
                    "external_ts": "Le décompte sera visible une fois transmis par l’employeur.",
                    "lift_ts_completed": "Le décompte est en attente de validation.",
                    "lift_ts_open": "Veuillez envoyer vos fiches horaires pour cette période afin que l'employeur puisse valider le décompte.",
                    "empty_period": "Ce décompte mensuel concerne uniquement les semaines se terminant avant le 20 du mois. Étant donné que l'activité a débuté après cette date, aucune semaine n’est incluse dans ce décompte.",
                    "auto_submitted": "Le décompte a été validé automatiquement le %{date} par Lift."
                }
            },
            "info_text_client": "Le décompte de %{workerName} a été soumis le %{date}.",
            "info_text_worker": "Décompte soumis le %{date} par %{clientName}.",
            "final_settlement": "Décompte final",
            "tracking_dates": "Période: %{period}",
            "is_extra_month": "Ce décompte concerne uniquement les heures supplémentaires, les vacances restantes, les frais et les déductions non encore pris en compte ; le salaire mensuel n’y est pas inclus.",
            "to_review": "À vérifier",
            "timesheets_empty": "Aucune fiche horaire n’a été enregistrée pour cette période.",
            "additions": {
                "title": "Autres éléments du décompte",
                "count_line": "{{title}} : {{count}} × {{unitPrice}}",
                "overtime_paid": "Heures supplémentaires payées",
                "overtime_paid_at": "{{hours}} payées à {{percent}} %"
            }
        },
        "payroll_breakdown_editor": {
            "title": "Décompte (modifier)",
            "cannot_load": "Impossible de charger le décompte",
            "snackbar_submitted": "Décompte soumis avec succès",
            "info_text": "Veuillez remplir le décompte.",
            "incomplete_timesheets": "Incomplet",
            "preview": "Résumé",
            "no_data": "Complétez les informations ci-dessus afin d'en voir le résumé",
            "invoice": "Facture (hors TVA)",
            "error_getting_summary": "Erreur lors du calcul du résumé",
            "product_keys": {
                "dynamic_fee": "Frais forfaitaires",
                "deduction": "Déductions",
                "salary": "Salaire",
                "bonus": "Bonus",
                "salary_monthly_full": "Salaire facturé",
                "salary_monthly_partial": "Salaire partiel facturé",
                "salary_daily": "Salaire journalier",
                "salary_hourly": {
                    "zero": "",
                    "one": "{{count}} heure à 100%",
                    "other": "{{count}} heures à 100%"
                },
                "salary_package": "Forfait",
                "salary_overtime_0": {
                    "zero": "",
                    "one": "{{count}} heure de travail supplémentaire",
                    "other": "{{count}} heures de travail supplémentaire"
                },
                "salary_overtime_25": {
                    "zero": "",
                    "one": "dont majoration de 25% pour {{count}} heure",
                    "other": "dont majoration de 25% pour {{count}} heures"
                },
                "salary_overtime_50": {
                    "zero": "",
                    "one": "dont majoration de 50% pour {{count}} heure",
                    "other": "dont majoration de 50% pour {{count}} heures"
                },
                "salary_bonus": "Bonus: {{description}}",
                "effective_fee": "Frais effectifs: {{description}}",
                "variable_fee": "Frais variables",
                "fee_public_transport": "{{repetition}} à {{unitPrice}} (Frais de transport public)",
                "fee_private_transport": "{{repetition}} à {{unitPrice}} (Frais de transport privé)",
                "fee_food": "{{repetition}} à {{unitPrice}} (Frais de repas)",
                "fee_phone": "{{repetition}} à {{unitPrice}} (Frais de téléphonie)",
                "fee_remote_work": "{{repetition}} à {{unitPrice}} (Frais liés au télétravail)",
                "fee_other": "{{repetition}} à {{unitPrice}} ({{description}})",
                "lift_deduction": "{{repetition}} à {{unitPrice}} ({{description}})",
                "with_charges": "Charges sociales incluses",
                "salary_overtime_0_from_balance": {
                    "zero": "",
                    "one": "{{count}} heure à {{percent}}% compensée depuis le solde",
                    "other": "{{count}} heures à {{percent}}% compensées depuis le solde"
                },
                "absence": "Absence",
                "salary_overtime_100": {
                    "zero": "",
                    "one": "dont majoration de 100% pour {{count}} heure",
                    "other": "dont majoration de 100% pour {{count}} heures"
                },
                "nb_days": {
                    "zero": "",
                    "one": "{{count}} jour",
                    "other": "{{count}} jours"
                },
                "nb_hours": {
                    "zero": "",
                    "one": "{{count}} heure",
                    "other": "{{count}} heures"
                },
                "paid_vacation": "Indemnité compensatrice de congés payés",
                "vacation_compensation": "Indemnisation du solde de vacances",
                "salary_overtime_15": {
                    "zero": "",
                    "one": "dont majoration de 15% pour {{count}} heure",
                    "other": "dont majoration de 15% pour {{count}} heures"
                }
            },
            "product_categories": {
                "vacation_compensation": "Indemnisation du solde de vacances",
                "salary": "Salaire",
                "bonus": "Bonus",
                "deduction": "Déductions forfaitaires",
                "dynamic_fee": "Frais forfaitaires journaliers",
                "effective_fee": "Frais effectifs",
                "variable_fee": "Frais forfaitaires autres",
                "absence": "Absence",
                "auxiliary_salary": "Activités annexes"
            },
            "error_saving": "Erreur lors de l'enregistrement du décompte",
            "preview_need_compute": "Salaire et total sous réserve de validation des absences.",
            "agree_breakdown_is_correct": "En le validant, vous certifiez que le décompte est exact et que les heures majorées ont bien été contrôlées.",
            "repetitions": {
                "worked_day": {
                    "zero": "",
                    "one": "{{count}} jour",
                    "other": "{{count}} jours"
                },
                "worked_month": {
                    "zero": "",
                    "one": "{{count}} mois",
                    "other": "{{count}} mois"
                },
                "count": {
                    "zero": "",
                    "one": "{{count}} occurrence",
                    "other": "{{count}} occurrences"
                }
            },
            "contact_us": "Contactez-nous si vous avez des questions",
            "review_timesheets": "Revoir les fiches horaires",
            "review_timesheets_description": "Ouvrez la page des fiches horaires liées à ce décompte, puis sélectionnez celle que vous souhaitez faire corriger. L’employé sera automatiquement informé et vous transmettra ensuite la version révisée.",
            "with_gross_amount": "{{title}} ({{amount}} brut)"
        },
        "phone_number_edit": {
            "title": "Numéro de téléphone",
            "phone_number": "Numéro de téléphone"
        },
        "invite_client": {
            "title": "Inviter un employeur",
            "invite": "Inviter",
            "copy_text": "Copier texte",
            "copied": "Copié",
            "description": "Pensez à inviter d’autres entreprises à vous rejoindre sur Lift et à vous embaucher directement via la plateforme! \nCela vous offre une vue d’ensemble claire de vos revenus et renforce votre protection sociale grâce à des cotisations centralisées auprès d’une seule caisse de pension.\n\nCôté employeur, c’est aussi un vrai plus: Lift prend en charge la gestion administrative du personnel et réduit les risques de non-conformité en matière de droit du travail et d’assurances sociales.\n\nUne solution simple, efficace et sécurisée pour toutes les parties.",
            "shared_title": "Lift app – Votre partenaire professionnel",
            "shared_message": "Bonjour,\n\nJe souhaite vous inviter en tant qu’employeur sur Lift afin d’établir un contrat de travail par la suite.\n\nConnectez-vous pour connaître vos avantages. Téléchargez l’app: https://app.liftapp.ch/invite/ ou rendez-vous sur notre site: https://webapp.liftapp.ch",
            "dismissed_action": "Partage annulé"
        },
        "fees_and_deductions": {
            "title": "Frais et déductions",
            "employeer_fees": "Frais à la charge de l'employeur",
            "talent_fees": "Frais à la charge de l'employé",
            "cct_fees": "Frais liés à la CCT",
            "fees_description": "%{amount} %{repetition}, charges sociales déduites"
        },
        "private_client_edit": {
            "title": "Employeur domestique"
        },
        "contract_preview": {
            "error": "Une erreur s'est produite lors de la récupération du contrat.",
            "loading_document": "Chargement du contrat…",
            "sign_contract": "Je signe le contrat",
            "other_sign_contract": "Choisir un autre signataire",
            "postpone_signing": "Signer plus tard",
            "valid_info": "Vous allez maintenant pouvoir signer votre contrat.",
            "invalid_info": "Le contrat a déjà été signé ou a expiré.",
            "other_sign_info": "Le contrat doit être signé par l'autre partie avant que vous ne puissiez le signer.",
            "title": "Prévisualisation du contrat",
            "cancel_amendment": "Annuler l'avenant",
            "delete_amendment": "Effacer l'avenant",
            "refuse_amendment": "Refuser l'avenant",
            "cancel_amendment_description": "Êtes-vous certain de vouloir annuler cet avenant?",
            "cancel_amendment_success": "L'avenant a été annulé avec succès",
            "sign_error": "Une erreur s'est produite lors de la signature du contrat.",
            "sign_success": "Contrat signé avec succès"
        },
        "mission_select_signer": {
            "description": "Sélectionnez une personne habilitée à signer",
            "error": "Une erreur s'est produite lors de la récupération des signataires.",
            "contract_sent": "Signataire sélectionné avec succès",
            "contract_send_error": "Une erreur s'est produite lors de l'envoi du contrat.",
            "no_other_signers": "Pour inviter un nouveau collègue signataire, cliquez sur “Signer plus tard”, puis rendez-vous dans Profil → Collègues → + Inviter un collègue.",
            "send_contract": "Envoyer le contrat",
            "postpone_signing": "Signer plus tard",
            "how_to_invite": "Comment ajouter vos collègues en tant que signataires?",
            "title": "Sélectionner le signataire",
            "invite_colleague": "Inviter un collègue signataire",
            "you": "{{name}} (vous)"
        },
        "invitation": {
            "title": "Invitation",
            "descriptions": {
                "client": "**{{clientName}}**\n**{{senderName}}** souhaiterait vous inviter dans son équipe.\n<br>\nEn rejoignant votre collègue, vous pourrez créer des contrats et engager des employés pour le compte de votre entreprise.\n<br>\nN’hésitez pas à [contacter l'assistance](intercom://) si vous avez des questions.",
                "worker": "**{{clientName}}**\n**{{senderName}}** souhaiterait collaborer avec vous.\n<br>\nEn acceptant, vous autorisez {{senderName}} à accéder à votre profil (CV, diplômes, certificats d'études) et à vous proposer des contrats de travail.\n<br>\nN’hésitez pas à [contacter l'assistance](intercom://) si vous avez des questions."
            },
            "alerts": {
                "client": {
                    "title": "Créer le profil employeur pour {{clientName}}",
                    "description": "Afin d'accepter l'invitation, il vous faut créer un profil employeur en lien avec l'entreprise.",
                    "confirm": "Créer profil employeur"
                },
                "worker": {
                    "title": "Créer le profil employé",
                    "description": "Afin d'accepter l'invitation, il vous faut créer un profil employé.",
                    "confirm": "Créer profil employé"
                }
            },
            "reject": "Refuser",
            "accept": "Accepter",
            "ignore": "Ignorer"
        },
        "mission_annexes": {
            "title": "Annexes",
            "intro": "Ces documents, ajoutés par l’employeur, restent sous la seule responsabilité de leurs auteurs; nous n’en vérifions ni la légalité, ni la conformité. En cas de contradiction, le contrat conclu avec {{legalEmployerName}} prévaut."
        },
        "reject_amendment": {
            "title": "Refuser l'avenant",
            "description": "Si vous souhaitez refuser l’avenant, merci d’en indiquer la raison.",
            "missing_other_reason": "Veuillez spécifier la raison.",
            "request_reason": "Raison de la demande d'annulation:",
            "reason_label": "Raison",
            "submit": "Refuser l'avenant",
            "success": "L'avenant a bien été refusé"
        },
        "cancel_amendment": {
            "title": "Indiquez la raison",
            "description": "Merci d’indiquer la raison pour laquelle vous souhaitez effacer l'avenant.",
            "missing_other_reason": "Veuillez spécifier la raison.",
            "reason_label": "Raison",
            "submit": "Annuler l’avenant",
            "success": "L’avenant a bien été annulé"
        },
        "client_framework_select_signer": {
            "description": "Sélectionnez une personne habilitée à signer",
            "contract_sent": "Signataire sélectionné avec succès",
            "contract_send_error": "Une erreur s'est produite lors de l'envoi du contrat.",
            "no_other_signers": "Pour inviter un nouveau collègue signataire, cliquez sur “Signer plus tard”, puis rendez-vous dans Profil → Collègues → + Inviter un collègue.",
            "send_contract": "Envoyer le contrat de co-emploi pour signature",
            "postpone_signing": "Signer plus tard",
            "title": "Sélectionner le signataire",
            "error": "Une erreur s'est produite lors de la récupération des signataires.",
            "how_to_invite": "Comment ajouter vos collègues en tant que signataires?",
            "invite_colleague": "Inviter un collègue signataire",
            "you": "{{name}} (vous)"
        },
        "client_contact_edit": {
            "title": "Coordonnées de contact",
            "description": "Ces coordonnées de contact sont associées à votre entreprise."
        }
    },
    "activities": {
        "actions": {
            "VerifyEmail": "Renvoyer l'e-mail de vérification",
            "MissionOnboardingRequired": "Fournir les informations relatives à l'activité",
            "InvitationNeedResponse": "Répondre à l'invitation",
            "ContractWorkerNeedSign": "Vérifier et signer le contrat",
            "ContractClientNeedSign": "Vérifier et signer le contrat",
            "ContractContinueSigning": "Poursuivre la signature du contrat",
            "WorkerNeedCompletion": "Compléter mon profil",
            "TimeSheetNeedCompletion": "Compléter mes heures",
            "TimeSheetNeedChanges": "Corriger mes heures",
            "TimeSheetNeedReview": "Vérifier et approuver les heures",
            "PayrollBreakdownNeedCompletion": "Compléter le décompte",
            "VerifyBusinessEmail": "Renvoyer l'e-mail de vérification",
            "NeedKyc": "Vérifier mon identité",
            "AmendmentWorkerNeedSign": "Vérifier et signer",
            "AmendmentClientNeedSign": "Vérifier et signer",
            "ClientContractNeedSign": "Vérifier et signer le contrat"
        }
    },
    "salary_projection": {
        "gross_salary": "Salaire brut",
        "net_salary": "Salaire net",
        "total_invoiced": "Total facturé (hors TVA)",
        "info": "Les montants ci-dessous sont calculés à titre indicatif.",
        "footer_variable_fees_not_included": "hors frais variables",
        "worker_payroll_taxes": "Dont charges sociales",
        "client_payroll_taxes": "Inclus charges patronales",
        "client_deduction": "Inclus déductions",
        "worker_deduction": "Dont déductions",
        "worker_fees": "Inclus frais forfaitaires",
        "client_fees": "Inclus frais forfaitaires"
    },
    "calendar": {
        "mission_title": "Contrat Lift %{title}",
        "mission_notes": "Contrat de travail entre '%{client}' et '%{worker}' comme '%{title}'",
        "mission_added": "Activité ajoutée à votre calendrier",
        "error_adding": "Erreur lors de l'ajout de l'activité à votre calendrier"
    },
    "nationalities": {
        "AL": "Albanais|Albanaise",
        "AD": "Andorran|Andorrane",
        "AT": "Autrichien|Autrichienne",
        "BY": "Biélorusse|Biélorusse",
        "BE": "Belge|Belge",
        "BA": "Bosnien|Bosnienne",
        "BG": "Bulgare|Bulgare",
        "HR": "Croate|Croate",
        "CY": "Chypriote|Chypriote",
        "CZ": "Tchèque|Tchèque",
        "DK": "Danois|Danoise",
        "EE": "Estonien|Estonienne",
        "FI": "Finlandais|Finlandaise",
        "FR": "Français|Française",
        "DE": "Allemand|Allemande",
        "GR": "Grec|Grecque",
        "HU": "Hongrois|Hongroise",
        "IS": "Islandais|Islandaise",
        "IE": "Irlandais|Irlandaise",
        "IT": "Italien|Italienne",
        "XK": "Kosovar|Kosovare",
        "LV": "Letton|Lettone",
        "LI": "Liechtensteinois|Liechtensteinoise",
        "LT": "Lituanien|Lituanienne",
        "LU": "Luxembourgeois|Luxembourgeoise",
        "MK": "Macédonien|Macédonienne",
        "MT": "Maltais|Maltaise",
        "MD": "Moldave|Moldave",
        "MC": "Monégasque|Monégasque",
        "ME": "Monténégrin|Monténégrine",
        "NL": "Néerlandais|Néerlandaise",
        "NO": "Norvégien|Norvégienne",
        "PL": "Polonais|Polonaise",
        "PT": "Portugais|Portugaise",
        "RO": "Roumain|Roumaine",
        "RU": "Russe|Russe",
        "SM": "Saint-Marinais|Saint-Marinaise",
        "RS": "Serbe|Serbe",
        "SK": "Slovaque|Slovaque",
        "SI": "Slovène|Slovène",
        "ES": "Espagnol|Espagnole",
        "SE": "Suédois|Suédoise",
        "CH": "Suisse|Suisse",
        "UA": "Ukrainien|Ukrainienne",
        "GB": "Britannique|Britannique"
    },
    "your_location": "Votre position",
    "image_chooser": {
        "error": "Une erreur est survenue lors de la récupération des images.",
        "invalid_image": "L'image sélectionnée ne peut pas être téléchargée."
    },
    "webImage": "Image sur le web",
    "confirm": "Confirmer",
    "submit": "Soumettre",
    "go_home": "Retour à l'accueil",
    "iAgree": "J'accepte",
    "fill_all_fields": "Veuillez remplir tous les champs.",
    "back": "Retour",
    "see_more": "Voir plus",
    "permission_denied": "La permission a été refusée. Accédez aux paramètres de votre téléphone.",
    "import": "Importer",
    "work_permit_short": {
        "permit_b": "Permis B",
        "permit_c": "Permis C",
        "permit_g": "Permis G",
        "permit_l": "Permis L",
        "permit_n": "Permis N",
        "permit_s": "Permis S",
        "permit_other": "Autre permis",
        "in_process": "En cours"
    },
    "deduction": {
        "title": "Déduction \"%{description}\""
    },
    "payrollSource": {
        "type": {
            "lift": "Fiche horaire Lift",
            "manual_client": "Fiche horaire externe",
            "gekos": "Fiche horaire Gek'os"
        }
    },
    "payroll_breakdown": {
        "open_info": "Le décompte mensuel sera visible ici une fois que l'employé aura complété ses fiches horaires pour cette période.",
        "submitted_info": "Validé le %{date} • %{name}",
        "waiting_submit": "En attente de validation",
        "error_not_a_number": "La saisie est incorrecte",
        "error_not_set": "Veuillez saisir une valeur",
        "delta_work_info": "Indiquez si le total d'heures de travail effectuées est inférieur ou supérieur au temps de travail fixé dans le contrat.",
        "delta_work_info_action": "Voir les détails du contrat",
        "field_total_vacation_days_title": "Indiquez si l’employé a pris des jours de vacances durant cette période.",
        "field_total_vacation_days": "Jour(s) de vacances pris",
        "field_total_work_days_title": "Indiquez le nombre de jours travaillés",
        "field_total_work_days_info": "Ce nombre servira à calculer l'ensemble des déductions et des frais forfaitaires journaliers. Les jours de vacances ou d’absence ne sont pas pris en compte.",
        "field_total_work_days": "Nombre de jours travaillés",
        "field_delta_work": "Indiquez si l’employé a réalisé des heures en plus ou en moins sans majoration.",
        "field_delta_work_mode_plus": "Heures à compenser",
        "field_delta_work_mode_minus": "Heures en moins",
        "field_delta_work_mode_zero": "Aucune heure en plus ou en moins",
        "field_total_work_title": "Nombre d'heures travaillées durant cette période",
        "button_submit": "Valider le décompte",
        "absence_days_title": "Absences",
        "timesheets": "Fiches horaires",
        "rejected_info": "Rejeté le %{date} • %{name}",
        "waiting_fill": "À compléter par l'employeur",
        "used_vacation_days_info": {
            "zero": "Solde vacances au %{date}: 0 jour",
            "one": "Solde vacances au %{date}: %{count} jour",
            "other": "Solde vacances au %{date}: %{count} jours"
        },
        "used_vacation_hours_info": {
            "zero": "Solde au %{date}: 0 heure",
            "one": "Solde au %{date}: %{count} heure",
            "other": "Solde au %{date}: %{count} heures"
        },
        "vacancy_by_days": "jours",
        "vacancy_by_hours": "heures",
        "field_total_vacation_hours": "Heures de vacances",
        "nav_title": "Décompte mensuel",
        "nav_title_no_repetition": "Décompte",
        "fees_and_deductions": "Détails frais et/ou déductions",
        "field_variable_fee_count": "Indiquez le nombre de \"{{feeName}}\" qui doivent être comptabilisés",
        "field_variable_fee_count_info": "{{feeCount}} brut par occurrence, soit {{withTaxes}} charges comprises",
        "delta_work_hours_info": "Solde d'heures: **{{symbol}} {{deltaWorkHours}}h ({{overtimeAmount}})**",
        "overtime_paid_125_150": {
            "title": "Indiquez si l’employé a réalisé des heures supplémentaires avec majoration.",
            "description": "Passé un certain seuil, les heures supplémentaires doivent être rémunérées à un taux majoré. [Règles pour le paiement des heures supplémentaires](intercom://10485414)",
            "link": "Règles de compensation selon la CCT"
        },
        "overtime_125": "Heures supplémentaires à 125%",
        "overtime_150": "Heures supplémentaires à 150%",
        "worked_hours": {
            "title": "Heures travaillées",
            "description": "Le décompte doit tenir compte des heures supplémentaires. Ces heures peuvent donner lieu à une majoration de 25% à 50%.",
            "link": "Règles de compensation selon la CCT"
        },
        "edit": "Éditer",
        "overtime_plus_25": "Heures supp. majoration +25%",
        "overtime_plus_50": "Heures supp. majoration +50%",
        "used_vacation_days_overflow": "Les jours de vacances pris ne peuvent dépasser le solde disponible de {{count}} jours.",
        "used_vacation_hours_overflow": "Les heures de vacances prises ne peuvent dépasser le solde disponible de {{count}} heures.",
        "next_to_validate_info": "Le décompte peut être rempli une fois que l'employé a effectué ses heures de travail pour cette période.",
        "overtime_paid_too_high": "Vous ne pouvez pas solder un nombre d'heures supérieur au nombre d'heures supplémentaires actuel ({{deltaWorkHours}}h)",
        "field_total_work_days_error": "Le nombre de jours travaillés n'est pas valide",
        "field_totalWork100Hours": "Heures à 100%",
        "field_totalWork125Hours": "Heures à 125%",
        "field_totalWork150Hours": "Heures à 150%",
        "error": {
            "max_vacation_days": "Le nombre de jours de vacances pris ne peut pas dépasser {{maxWorkDays}} jours.",
            "total_work_days": "Le nombre de jours travaillés ne peut pas dépasser {{maxWorkDays}} jours.",
            "min_total_work_days": "Le nombre de jours travaillés ne peut pas être moins que {{minWorkDays}} jours."
        },
        "field_totalWork200": "Heures à 200%",
        "dynamic_fees": "Frais forfaitaires",
        "field_delta_work_description": "Les heures supplémentaires sans majoration (100%) sont ajoutées à la [cagnotte de vacances](intercom://11688064). Cette dernière peut être reversée, entièrement ou en partie, à l’employé puis facturée à l’employeur.",
        "field_total_work_days_description": "Ce nombre constituera la base de calcul des déductions et des frais forfaitaires journaliers, hors jours de vacances et d’absence.",
        "extras": "Les extras",
        "enter_absence": "Saisir une absence",
        "refund_or_pay": "Rembourser / payer",
        "pay_bonus": "Verser un bonus à l'employé",
        "refund_effective_fees": "Rembourser les frais effectifs",
        "refund_effective_fees_description": "Ces frais relèvent de notes de frais ponctuelles enregistrées au cours de la période concernée.",
        "pay_overtime_work": "Payer les heures supplémentaires (+{{overtimeDeltaHours}}h)",
        "monthly": {
            "delta_work": {
                "title": "Indiquez si l’employé a fait des heures en plus (sans majoration) ou en moins.",
                "description": "Une [certaine flexibilité](intercom://9983353) est envisageable: il est possible de travailler davantage une semaine et moins la suivante, tant que la moyenne mensuelle reste conforme au contrat."
            },
            "overtime_paid": {
                "title": "Indiquez si l’employé a réalisé des heures supplémentaires avec majoration.",
                "description": "Passé un certain seuil, les heures supplémentaires doivent être rémunérées à un taux majoré. [Règles pour le paiement des heures supplémentaires](intercom://10485414)"
            },
            "vacations": {
                "title": "Indiquez si l’employé a pris des jours de vacances durant cette période."
            },
            "worked_days": {
                "description": "Ce nombre constituera la base de calcul des déductions et des frais forfaitaires journaliers, hors jours de vacances et d’absence."
            }
        },
        "hourly": {
            "delta_work": {
                "title": "Indiquez si l’employé a fait des heures en plus (sans majoration) ou en moins.",
                "description": "Une [certaine flexibilité](intercom://9983353) est envisageable: il est possible de travailler davantage une semaine et moins la suivante, tant que la moyenne mensuelle reste conforme au contrat."
            },
            "overtime_paid": {
                "title": "Indiquez le nombre d’heures travaillées: heures de bureau (100%) ou heures supplémentaires majorées (125%, 150%).",
                "description": "Toute heure de travail effectuée en dehors des horaires standards de bureau donne droit à une majoration de 125% ou 150% du salaire horaire. [Règles de compensation selon la CCT](intercom://10485414)"
            },
            "vacations": {
                "title": "Indiquez si l’employé a pris des vacances durant cette période."
            },
            "worked_days": {
                "description": "Ce nombre sert au calcul des déductions et des frais forfaitaires. Les jours de vacances ou d’absence ne sont pas pris en compte."
            }
        },
        "overtime_200": "Heures supplémentaires à 200%",
        "field_totalWork200Hours": "Heures à 200%",
        "overtime_plus_100": "Heures supp. majoration +100%",
        "overtime_plus_15": "Heures supp. majoration +15%",
        "nav_title_final_settlement": "Décompte final",
        "field_totalWork115Hours": "Heures à 115%",
        "overtime_115": "Heures supplémentaires à 115%",
        "pending_amendment_warning": {
            "title": "Avenant en attente de validation",
            "awaiting_client": "L’avenant est actuellement en attente de votre signature, ce qui bloque l’envoi du décompte.",
            "awaiting_worker": "L’avenant est actuellement en attente de signature de l'employé, ce qui bloque l’envoi du décompte. N’hésitez pas à prendre contact avec l'employé afin de débloquer la situation.",
            "awaiting_basquiat": "L’avenant est actuellement en attente de signature de notre équipe. Celle-ci ne saurait tarder, ce qui permettra l’envoi du décompte dans les plus brefs délais."
        },
        "used_vacation_minutes_info": {
            "zero": "Solde au %{date}: 0 minute",
            "one": "Solde au %{date}: %{count} minute",
            "other": "Solde au %{date}: %{count} minutes"
        },
        "vacancy_by_minutes": "–",
        "used_vacation_minutes_overflow": "Les minutes de vacances prises ne peuvent dépasser le solde disponible de {{count}} minutes.",
        "vacation_by_days": "jours",
        "vacation_by_hours": "heures",
        "vacation_by_minutes": "minutes",
        "field_variable_fee_count_with_unit": "Indiquez le nombre de {{perUnit}} pour \"{{feeName}}\" qui doivent être comptabilisés",
        "pay_auxiliary_salary": "Payer une activité annexe",
        "pay_auxiliary_salary_description": "Forfait tout compris pour une activité annexe (accueil, ouverture du studio, etc.)."
    },
    "absence": {
        "add_title": "Saisir une absence",
        "remove_title": "Supprimer l'absence",
        "remove_info": "Êtes-vous sûr de vouloir supprimer cette absence?",
        "remove_action": "Oui, supprimer",
        "field_type": "Motif de l'absence",
        "field_start": "Date de début",
        "field_end": "Date de fin",
        "field_description": "Commentaire",
        "error_end_before_start": "La date de fin doit être postérieure à la date de début.",
        "type": {
            "military": "Service militaire",
            "sickness": "Maladie",
            "accident": "Accident",
            "maternity": "Maternité/Paternité",
            "training": "Formation",
            "sickness_close_relative": "Maladie d'un proche",
            "death_close_relative": "Décès d'un proche",
            "marriage": "Mariage",
            "moving": "Déménagement",
            "other": "Autre"
        },
        "title": "Absence",
        "timeFromTo": "{{from}} à {{to}}"
    },
    "assistance": "Assistance",
    "pendingVerification": {
        "soon": "On se réjouit de vous accueillir sur Lift!",
        "change_profile": "Changer de profil"
    },
    "webImageDownloadError": "Erreur lors du téléchargement de l'image",
    "optional": "Optionnel",
    "profile_switch": {
        "on_change": {
            "client": "Profil employeur {{name}} activé",
            "private_client": "Profil employeur activé",
            "worker": "Profil employé activé"
        },
        "not_found": "Le profil associé est introuvable"
    },
    "login": "Se connecter",
    "ijm": {
        "top_text": "L’assurance Groupe Mutuel couvre 80% du salaire brut sous forme d’indemnités journalières en cas de maladie, dès la fin du délai d’attente.",
        "ijm_group": {
            "title": "Choisissez le délai d’attente",
            "info": "Plus le délai d’attente est court, plus la cotisation est élevée.",
            "place_holder": "Choisissez le délai d’attente"
        },
        "ijm_plan_title": "Préférences du plan",
        "ijm_pay_first_days": {
            "info": "Souhaitez vous prendre en charge le salaire pendant les 2 premiers jours de maladie?",
            "in_list": {
                "yes": "2 premiers jours payés",
                "no": "2 premiers jours non payés"
            },
            "select": {
                "yes": "Oui, je paie les 2 premiers jours",
                "no": "Non, je ne les paie pas",
                "place_holder": "Choix de la couverture"
            }
        },
        "ijm_pay_remaining_percents": {
            "info": "Après le délai d’attente, l’assurance couvre 80% du salaire brut. Souhaitez-vous couvrir une partie restante du salaire?",
            "place_holder": "Choisissez le pourcentage",
            "chooser": {
                "0": "80% (0% payé par l'employeur)",
                "10": "90% (+10% payés par l'employeur)",
                "20": "100% (+20% payés par l'employeur)"
            },
            "in_list": {
                "0": "Indemnités: 80%",
                "10": "Indemnités: 90% (+10%)",
                "20": "Indemnités: 100% (+20%)"
            },
            "select": {
                "0": "Non, je laisse l'assurance couvrir les 80% du salaire.",
                "10": "Oui, je complète à 90% (j'ajoute 10%)",
                "20": "Oui, je complète à 100% (je paie les 20% restants)",
                "place_holder": "Choix du complément"
            }
        },
        "profile": {
            "title": "Plan Indemnités journalières en cas de maladie (IJM)",
            "to_complete": "À compléter",
            "missing_group": "Aucun plan sélectionné"
        },
        "mission": {
            "title": "Plan Indemnités journalières en cas de maladie (IJM)"
        },
        "contact_support_text": "Pour tout changement, veuillez contacter l’assistance.",
        "contact_support_action": "Assistance",
        "screen_title": "IJM",
        "save_success": "Les préférences du plan ont été enregistrées",
        "editor": {
            "root": {
                "title": "Choisissez la couverture de votre employé en cas de maladie",
                "text_1": "En Suisse, l’employeur a l’obligation de continuer à payer le salaire de l'employé en cas d’incapacité de travail liée à une maladie.\n\nDans le cadre de la Location de services, cette obligation inclut la souscription à une assurance-Indemnité journalière en cas de maladie (IJM), qui prend en charge le salaire en cas d’arrêt maladie prolongé.",
                "title_2": "Veuillez choisir la couverture adaptée à votre employé",
                "collaboration": "En collaboration avec",
                "wantIjm": "Souhaitez-vous souscrire à une assurance–Indemnité journalière en cas de maladie (IJM) pour votre employé?",
                "text_lse": "En Suisse, l’employeur a l’obligation de continuer à payer le salaire de l'employé en cas d’incapacité de travail liée à une maladie.\n\nDans le cadre de la location de services, cette obligation inclut la souscription à une assurance–Indemnité journalière en cas de maladie (IJM), qui prend en charge le salaire en cas d’arrêt maladie prolongé.",
                "text_is_mandatory": "En Suisse, l’employeur a l’obligation de continuer à payer le salaire de l'employé en cas d’incapacité de travail liée à une maladie.\n\nDans le cadre de la CCT {{cctName}}, cette obligation inclut la souscription à une assurance–Indemnité journalière en cas de maladie (IJM), qui prend en charge le salaire en cas d’arrêt maladie prolongé.",
                "text_not_mandatory": "En Suisse, l’employeur a l’obligation de continuer à payer le salaire de l'employé en cas d’incapacité de travail liée à une maladie.\n\nVous avez la possibilité de souscrire à une assurance–Indemnité journalière en cas de maladie (IJM), qui prend en charge le salaire en cas d’arrêt maladie prolongé.",
                "no_lse_comment": "Attention: Le maintien du salaire durant le délai d'attente et le complément nécessaire pour atteindre le minimum légal ou conventionnel restent à votre charge, même si vous choisissez de ne pas verser de supplément au-delà des 80 % de l'IJM."
            },
            "group_select": {
                "title": "Sélectionnez le délai d’attente",
                "text_1": "L’assurance IJM verse 80% du salaire après un délai d’attente qui correspond à la période pendant laquelle vous continuez à payer le salaire de votre employé avant que l’assurance prenne le relais.\n\nPar exemple, avec un délai d’attente de 30 jours, vous vous engagez à verser le salaire de votre employé pendant les 30 premiers jours d’arrêt maladie.",
                "title_2": "Choisissez une option parmi les 3 plans",
                "renew_text": "Le choix du plan s’applique à l’ensemble de vos employés sur Lift. Vous pouvez le modifier en début d’année en contactant notre service d’assistance."
            },
            "waiting_select": {
                "title": "Souhaitez-vous couvrir les 2 premiers jours d’arrêt maladie?",
                "text_1": "Les 2 premiers jours d’absence pour maladie (jours de carence) ne sont pas couverts par l’assurance IJM.\n\nVous avez toutefois la possibilité de les compenser vous-même, en partie ou en totalité, afin de garantir un revenu continu à votre employé.",
                "title_2": "Choisissez une option"
            },
            "cover_select": {
                "title": "Souhaitez-vous verser les 20% restants du salaire?",
                "text_1": "L’assurance IJM prend en charge 80% du salaire brut en cas de maladie.\n\nVous avez la possibilité de compléter tout ou partie des 20% restants, pour que votre employé continue à toucher jusqu’à 100% de son salaire habituel.",
                "title_2": "Sélectionnez une option parmi les 3 choix suivants"
            }
        },
        "data": {
            "descriptions": {
                "item_1": {
                    "zero": "",
                    "one": "",
                    "other": "L'assurance commence au {{count}}e jour"
                },
                "item_2": "Vous payez le salaire du {{payFromDay}} au {{payToDay}}",
                "item_3": "Cotisation: {{percent}}% du salaire brut, soit {{amount}}",
                "item_3b": "Cotisation: {{percent}}% du salaire brut",
                "item_2_nothing_to_pay": "Aucun salaire à payer"
            }
        },
        "configuration_list": {
            "screen_title": "Plans IJM",
            "no_cct": "Sans CCT",
            "all_workers": "Tous les employés",
            "group": "Groupe {{group}}",
            "no_plans": "Aucun plan configuré",
            "no_plans_description": "Aucune configuration IJM n'a été définie pour votre entreprise.",
            "no_ijm": "Pas d'IJM",
            "no_cct_lse": "Location de services"
        },
        "no_ijm": "Aucune assurance IJM sélectionnée",
        "viewer": {
            "root": {
                "text_1": "Voici la configuration actuelle de votre plan IJM. Contactez l’assistance pour toutes questions ou modification.",
                "collaboration": "En collaboration avec",
                "no-ijm": "Il n'y a pas de plan IJM appliqué pour le groupe \"{{cctLabel}}\"."
            },
            "group_select": {
                "title": "Délai d’attente"
            },
            "waiting_select": {
                "title": "Couverture des 2 premiers jours d’arrêt maladie?"
            },
            "cover_select": {
                "title": "Paiement des 20% restants du salaire?"
            }
        }
    },
    "type_to_search": "Tapez les trois premières lettres pour commencer votre recherche.",
    "no_result": "Malheureusement, aucun résultat ne correspond à votre recherche.",
    "add": "Ajouter",
    "seeMore": "Voir plus",
    "seeLess": "Voir moins",
    "bonus": {
        "title": "Bonus",
        "add_title": "Ajouter un bonus pour l'employé",
        "amount_title": "Veuillez indiquer le montant du bonus",
        "amount_subtitle": "Les bonus sont soumis aux charges sociales mais pas à la LPP.",
        "amount_with_social_charges": "{{amount}} charges comprises",
        "remove_title": "Supprimer le bonus",
        "remove_info": "Êtes-vous sûr de vouloir supprimer le bonus?",
        "remove_action": "Oui, supprimer",
        "field_description": "Description du bonus"
    },
    "effective_fee": {
        "title": "Frais effectifs",
        "add_title": "Ajouter des frais effectifs",
        "amount_title": "Veuillez indiquer le montant à rembourser",
        "remove_title": "Supprimer ce frais",
        "remove_info": "Êtes-vous sûr de vouloir supprimer ce frais?",
        "remove_action": "Oui, supprimer",
        "field_description": "Description"
    },
    "veriff": {
        "generic_error": "No Veriff session URL, please reset your KYC",
        "title": "Vérification d'identité"
    },
    "dateTimeAt": "{{date}} à {{time}}",
    "overtimePaid": {
        "title": "Solde d'heures",
        "add_title": "Voir les heures supplémentaires",
        "amount_title": "Veuillez indiquer le nombre d'heures que vous souhaitez compenser.",
        "delta_work_hours_info": "Solde d'heures: **{{symbol}} {{deltaWorkHours}}h ({{overtimeAmount}})**",
        "hours_equivalent": "{{hours}}h représente {{amount}}",
        "pay_hours": {
            "zero": "",
            "one": "Payer {{hours}} heure supp. ({{amount}})",
            "other": "Payer {{hours}} heures supp. ({{amount}})"
        },
        "remove_title": {
            "zero": "",
            "one": "Supprimer l'heure supp.",
            "other": "Supprimer les heures supp."
        },
        "remove_info": {
            "zero": "",
            "one": "Êtes-vous sûr de vouloir supprimer cette heure supp.?",
            "other": "Êtes-vous sûr de vouloir supprimer ces heures supp.?"
        },
        "remove_action": "Oui, supprimer",
        "overtime_paid_too_high": "Nombre d'heures maximum: {{deltaWorkHours}}h",
        "description_intro_by_cct": {
            "default": "Le solde ci-dessous indique le nombre d’heures normales (à 100%) effectuées en plus ou en moins depuis le début de l'activité.",
            "paysagiste": "Le solde ci-dessous indique le nombre d’heures majorées à 125% (selon la CCT Paysagiste VD) effectuées en plus ou en moins depuis le début de l'activité."
        },
        "description_end": "Elles correspondent à des [heures de travail normales](intercom://10485414) effectuées en plus depuis le début de l'activité. Elles peuvent être compensées soit par un versement salarial (cf. ci-dessous), soit par un repos compensatoire équivalent, accordé sous forme d’absences sur le temps de travail habituel."
    },
    "clear": "Effacer",
    "delete": "Supprimer",
    "done": "Terminé",
    "browser_recommendation": "Pour garantir une expérience fluide, nous vous recommandons d’utiliser les navigateurs Safari ou Chrome.\nCela vous permettra de profiter pleinement de toutes les fonctionnalités de notre plateforme.",
    "version_informations": "Informations concernant cette version",
    "ok": "OK",
    "prevent_going_back": {
        "go_back": "Quitter la page?",
        "quit": "Quitter",
        "informations_might_not_be_saved": "Les informations saisies pourraient ne pas être enregistrées."
    },
    "confirm_question": "Confirmer?",
    "timePeriod": {
        "monthly": "{{amount}} / mois",
        "hourly": "{{amount}} / heure",
        "daily": "{{amount}} / jour",
        "package": "{{amount}} / contrat"
    },
    "custom_name": "Nom personnalisé",
    "cct_labels": {
        "no_cct_lse": "Location de services",
        "no_cct": "Sans CCT"
    },
    "alerts": {
        "mission_needs_signature": {
            "title": "Signature requise",
            "description": "Le contrat est entré en vigueur. Il ne manque plus que votre signature pour régulariser votre situation.",
            "sign_contract": "Signer le contrat",
            "view_contract": "Voir le contrat"
        }
    },
    "language": {
        "change": "Changer de langue",
        "service_changed": "La langue du service a été changée en français.",
        "update_error": "La langue n'a pas pu être modifiée.",
        "name": {
            "fr": "Français",
            "de": "Allemand"
        }
    },
    "auxiliary_salary": {
        "title": "Activité annexe",
        "field_description": "Description de l'activité annexe",
        "hours_title": "Veuillez indiquer le nombre d’heures couvertes par ce forfait.",
        "amount_title": "Veuillez indiquer le montant brut du forfait",
        "amount_subtitle": "Montant tout compris : les indemnités de vacances et de jours fériés sont incluses."
    }
}